// AUTO-STRUCTURED locale file. Keys mirror en.ts exactly; missing keys fall back
// to English (see src/i18n/index.ts). Placeholders use {name} interpolation.
export default {
 modelAuthorization: {
  "title": "ChatGPT に接続",
  "description": "ChatGPT アカウントで個人のクラウドタスクを実行します。",
  "name": "接続名",
  "enterCode": "ChatGPT の認証ページで次のコードを入力してください：",
  "openProvider": "ChatGPT の認証ページを開く",
  "enableDevice": "ChatGPT のセキュリティ設定でデバイスコードログインを有効にしてください。認証後、このページが自動的に結果を確認します。",
  "chooseModels": "接続しました。この画面を閉じてモデル一覧から使用するモデルを選択してください。",
  "cancel": "認証をキャンセル",
  "retry": "再確認",
  "reauthorize": "再認証",
  "done": "完了",
  "connect": "ChatGPT に接続",
  "failed": "認証に失敗しました。再試行してください。",
  "state": {
    "pending": "認証を待っています",
    "ready": "接続済み",
    "expired": "認証コードの有効期限が切れました。再度開始してください。",
    "requires_reauth": "認証が必要です"
  }
},
  cloudRemoteInspector: {
    noModels: "このデバイスで利用できるモデルがありません。デバイスでプロバイダーを設定するか、個人用クラウドモデルを追加してください。",
    modelSettings: "モデル設定",
    fullPreview: "対象ブランチに対するコミット済み・未コミットの変更を表示します。選択したファイルのみ公開されます。",
    "createDraft": "下書きプルリクエストを作成",
    "deliveryUpgrade": "確認済みの変更を公開するには、デバイスの jcode を更新してください。",
    "close": "閉じる",
    "delivering": "公開中…",
    "publishDraft": "ブランチをプッシュして下書きを作成",
    "delivered": "下書きプルリクエストを作成しました。",
    "openPR": "プルリクエストを開く",
    "deliveryExplanation": "確認したファイルを選択してください。デバイスの Git と GitHub CLI の認証情報を使用して別のブランチをプッシュします。現在のブランチ、ファイル、ステージング領域は保持されます。",
    "defaultBase": "対象：リポジトリのデフォルトブランチ",
    "prTitle": "プルリクエストのタイトル",
    "prBody": "説明（任意）",
    "selectFiles": "公開するファイルを選択",
    "viewPatch": "差分を確認",

    "title": "タスク情報",
    "changes": "変更",
    "details": "詳細",
    "upgradeRequired": "ワークスペースの変更を表示するには、このデバイスの jcode を更新してください。",
    "setup": "デバイス接続ガイド",
    "files": "{count} ファイル",
    "refresh": "更新",
    "offline": "デバイスがオフラインです。再接続して変更を更新してください。",
    "workspaceChanges": "HEAD に対する現在の変更です。このタスク以前の変更も含まれます。",
    "clean": "未コミットの変更はありません。",
    "truncated": "表示上限を超えたため、プレビューは一部のみです。デバイスで変更全体を確認してください。",
    "updated": "更新時刻 {time}",
    "device": "デバイス",
    "workspace": "ワークスペース",
    "branch": "ブランチ",
    "model": "モデル",
    "connection": "接続状態",
    "online": "オンライン",
    "offlineLabel": "オフライン",
    "version": "jcode バージョン",
    "openDevice": "デバイスを開く",
    "binary": "バイナリファイルです。デバイスで内容を確認してください。"
},
  cloudRefresh: {
    "noGitProviders": "Git ログインプロバイダーが未設定です。管理者にプロバイダー接続の設定を依頼してください。",
    "sessionNotFound": "セッションが見つかりません",
    "addAttachments": "ファイルを追加",
    "uploading": "アップロード中…",
    "attachmentReady": "添付済み",
    "attachmentExpired": "期限切れ — 再アップロードしてください",
    "uploadFailed": "アップロードに失敗しました。再試行するかファイルを削除してください。ストレージが利用できない場合は管理者に連絡してください。",
    "attachmentLimits": "最大10ファイル、各25 MiB、合計100 MiB。空のファイルは添付できません。",
    "removeAttachment": "{name} を削除",

    "navigationFailed": "最近の作業を読み込めませんでした。",
    "accountRequired": "個人アカウントでログインして設定を管理してください。",
    "noMatchingDevices": "一致するデバイスはありません",
    "personalModelsEmpty": "上で個人用プロバイダーを追加するか、管理者にモデルの利用許可を依頼してください。",

    "personalModelsDescription": "個人用モデルはアクセス可能なすべてのリポジトリで使えます。",
    "updateCredentials": "認証情報を更新",
    "enable": "有効化",
    "disable": "無効化",
    "deleteModel": "{name} を削除",
    "deleteModelConfirm": "モデル {name} を削除しますか？",
    "availableModels": "タスクで使用できるモデル",

    "defaultModel": "既定のモデル",
    "automaticModel": "利用可能なモデルを自動選択",
    "unavailableModel": "モデルを利用できません。別のモデルを選択してください",
    "defaultPermission": "既定の実行権限",
    "askApproval": "承認を求める",
    "fullAccess": "フルアクセス",
    "planMode": "計画のみ",
    "defaultEffort": "既定の推論レベル",
    "effort_auto": "自動",
    "effort_low": "低",
    "effort_medium": "中",
    "effort_high": "高",
    "light": "ライト",
    "dark": "ダーク",
    "sendKey": "メッセージの送信方法",

    "recentRepositories": "最近のリポジトリ",
    "remoteDevices": "リモートデバイス",
    "recentConversations": "最近の会話",
    "allRepositories": "すべてのリポジトリ",
    "personalWorkspace": "個人ワークスペース",
    "homeTitle": "次は何に取り組みますか？",
    "homeDescription": "アイデアから始めましょう。jcode が作業を進めます。",
    "searchTasks": "タスクを検索",
    "all": "すべて",
    "active": "進行中",
    "attention": "対応が必要",
    "completed": "完了",
    "noMatch": "一致するタスクはありません",
    "noMatchDescription": "検索語を変えるか、フィルターを解除してください。",
    "clearFilters": "フィルターを解除",
    "connectDevice": "デバイスを接続",
    "searchDevices": "デバイスを検索",
    "devicesTitle": "デバイスで作業を続けましょう",
    "devicesDescription": "jcode にログイン済みのデバイスでワークスペースを開きます。",
    "noDevices": "接続済みデバイスはありません",
    "noDevicesDescription": "デバイスの jcode を接続してリモート作業を始めましょう。",
    "backDevices": "デバイス一覧に戻る",
    "startRemote": "リモートタスクを開始",
    "recentSessions": "最近のセッション",
    "deviceNotFound": "デバイスが見つかりません",
    "deviceUnavailable": "デバイスが利用できないか、アクセス権がありません。",
    "encryptedSession": "暗号化されたセッション",
    "pairToRead": "このブラウザーをペアリングすると会話を閲覧できます。"
},
  cloudDeviceGuide: {
    installHint: 'リモートワークスペース機能を使用するには、このデバイスに最新版の jcode をインストールしてください。',
    download: 'jcode をダウンロード・更新',
    "secure": "エンドツーエンド暗号化接続",
    "section": "リモート接続",
    "title": "jcode デバイスを接続",
    "description": "ログインしてデバイスを承認し、このブラウザーをペアリングすると、暗号化されたワークスペースと会話を開けます。",
    "steps": "リモート接続の手順",
    "login": "jcode にログイン",
    "approve": "デバイスを承認",
    "pair": "暗号化ペアリング",
    "newDevice": "新しいリモートデバイス",
    "minute": "約1分",
    "runCommand": "ログインコマンドを実行",
    "getCode": "ワンタイムデバイスコードを取得",
    "confirmIdentity": "デバイスの確認",
    "approveAccount": "アカウントへのアクセスを承認",
    "completePair": "ペアリングを完了",
    "approveLocal": "ローカルの jcode で承認",
    "onDevice": "接続するデバイスで",
    "runLogin": "jcode login を実行",
    "commandDescription": "コマンドがワンタイム認証コードを作成し、ブラウザーを自動で開きます。開かない場合は、以下にコードを入力してください。",
    "terminal": "ターミナル",
    "copyCommand": "ログインコマンドをコピー",
    "copyError": "コピーできませんでした。上のコマンドを選択してコピーしてください。",
    "enterCode": "CLI に表示されたコードを入力",
    "continue": "認証を続ける",
    "ciphertext": "Cloud は暗号文だけを転送します",
    "ciphertextDescription": "デバイスコードはログインをアカウントに関連付けます。ペアリング鍵は jcode とこのブラウザーに保持され、サーバーは会話を読み取れません。",
    "connected": "接続済み",
    "connectedDescription": "デバイスのワークスペースを開くか、上の手順で別のデバイスを追加してください。",
    "expires": "認証コードの有効期限は jcode に表示されます。"
},
  common: {
    ok: 'OK',
    add: '追加',
    back: '戻る',
    cancel: 'キャンセル',
    close: '閉じる',
    save: '保存',
    saving: '保存中…',
    saved: '保存済み',
    delete: '削除',
    remove: '削除',
    edit: '編集',
    rename: '名前変更',
    retry: '再試行',
    loading: '読み込み中…',
    enable: '有効化',
    disable: '無効化',
    search: '検索',
    done: '完了',
    other: 'その他',
    details: '詳細',
    connected: '接続済み',
    disconnected: '未接続',
    configured: '設定済み',
    notConfigured: '未設定',
    recommended: '推奨',
    copy: 'コピー',
    copied: 'コピーしました',
    dismiss: '閉じる',
    create: '作成',
    creating: '作成中…',
    confirm: '確認',
    continue: '続行',
  },

  language: {
    label: '言語',
  },

  format: {
    justNow: 'たった今',
    minutesAgo: '{n}分前',
    hoursAgo: '{n}時間前',
    daysAgo: '{n}日前',
    durationSeconds: '{n}秒',
    durationMinutes: '{m}分',
    durationMinutesSeconds: '{m}分{s}秒',
    durationHoursMinutes: '{h}時間{m}分',
  },

  run: {
    permissionArgumentsUnavailable: 'この以前の承認リクエストには実際の引数が保存されていません。',
    thinking: '考え中',
    thinkingAria: '考え中…',
    projectMember: 'リポジトリメンバー',
    toolStatusDone: '完了',
    tool: {
      read: 'プロジェクトコンテキストを読み取り',
      edit: 'ファイルを編集',
      execute: 'コマンドを実行',
      search: 'ワークスペースを検索',
    },
    toolStatus: {
      running: '実行中',
      failed: '失敗',
      queued: 'キュー待ち',
      canceled: 'キャンセル済み',
    },
    statusName: {
      queued: 'キュー待ち',
      running: '実行中',
      succeeded: '成功',
      failed: '失敗',
      canceled: 'キャンセル済み',
      scheduling: 'スケジューリング',
      awaiting_input: '入力待ち',
      blocked: 'ブロック中',
    },
    unknownStatus: '不明',
    finalStatus: '最終ステータス: {status}',
    status: 'ステータス: {status}',
    artifactReady: 'アーティファクトの準備完了: {artifact}',
    pushedAt: '{branch} を {sha} でプッシュしました',
    pushed: '{branch} をプッシュしました',
    result: {
      noChanges: 'コード変更なし',
      generic: '結果',
    },
    session: {
      resumed: 'セッションを再開しました',
      established: 'セッションを確立しました',
      finished: 'セッションが終了しました',
      finishedIdle: 'セッションが終了しました（アイドルタイムアウト）',
    },
    permissionTimedOut: '権限がタイムアウトしました',
    permissionResolved: '権限が解決されました',
    unknownEvent: '不明なイベント: {type}',
    toolStarted: '{tool} を開始しました',
    toolFailed: '{tool} が失敗しました',
    toolCompleted: '{tool} が完了しました',
    permission: {
      label: '権限',
      required: '権限が必要です',
      noAction: '操作なし（キャンセル済み）',
      timedOut: 'タイムアウトしました',
      resolved: '解決済み',
      answered: '回答済み — エージェントを待っています…',
      readonly: '読み取り専用 — リポジトリメンバーが回答できます。',
    },
  },

  workspace: {
    provider: {
      pathOrUrl: 'パス / リモート URL',
      gitRepository: 'Git リポジトリ',
    },
    runKind: {
      review: 'レビュー',
      prEvent: 'PR イベント',
      schedule: 'スケジュール',
      kanban: 'Kanban',
      webhook: 'Webhook',
      session: 'セッション',
      task: 'タスク',
    },
  },

  shell: {
    skipToContent: 'コンテンツにスキップ',
    globalNav: 'グローバルナビゲーション',
    primaryNav: 'メイン',
    workspaceEyebrow: 'ワークスペース',
    adminEyebrow: '管理',
    clusterTitle: 'Cluster',
    cloudTitle: 'jcode Cloud',
    clusterSubtitle: 'Cluster 設定',
    cloudSubtitle: 'セルフホスト型コーディングワークスペース',
    projects: 'プロジェクト',
    cluster: 'Cluster',
    devices: 'デバイス',
    clusterSections: 'Cluster セクション',
    adminBadge: '管理者',
    recentProjects: '最近の Repositories',
    recentEmpty: '開いた Repository がショートカットとしてここに表示されます。',
    recentAria: '最近の Repositories',
    workspaceAria: 'jcode Cloud ワークスペース',
    demoEnv: 'demo / local',
    orchestratorEnv: 'orchestrator',
    demoTag: 'DEMO',
    switchToLight: 'ライトモードに切り替え',
    switchToDark: 'ダークモードに切り替え',
    services_one: '{count} 件のサービス',
    services_other: '{count} 件のサービス',
    crumbProjects: 'プロジェクト',
    crumbNewProject: '新規プロジェクト',
    crumbCluster: 'Cluster',
    crumbModels: 'モデル',
    crumbConnections: '接続',
    crumbOverview: '概要',
    crumbWorkspace: 'ワークスペース',
    crumbProject: 'プロジェクト',
    crumbDevice: 'デバイス',
    crumbSession: 'セッション',
    crumbNotFound: '見つかりません',
  },

  cluster: {
    accessDenied: {
      roleCode: 'ROLE / PROJECT ADMIN',
      title: 'Cluster はこのロールの範囲外です。',
      body: 'このロールはリポジトリのみを管理します。キャパシティ、モデルの認証情報、ガードレール、プロバイダー設定には Cluster 管理者が必要です。',
      noticeTitle: 'Cluster ナビゲーションは意図的に非表示にされています。',
      noticeBody: 'この直接ルートは、システムスナップショットのリクエストを発行せずに境界を説明します。',
      backToProjects: 'リポジトリに戻る',
    },
    overview: {
      loadingSnapshot: 'Cluster スナップショットを読み込み中…',
      snapshotLoadError: 'Cluster スナップショットを読み込めませんでした',
      eyebrow: 'オーケストレータースナップショット',
      title: 'Cluster',
      description: 'このオーケストレーターのキャパシティ、ガードレール、ランタイム構成。編集可能な設定は各所有セクションにあります。',
      metaNamespace: 'namespace / {value}',
      metaLauncher: 'launcher / {value}',
      metaCommit: 'commit / {value}',
      snapshotLoaded: 'スナップショット読み込み済み',
      refresh: '更新',
      capacitySummaryAria: '実行キャパシティの概要',
      metricRunning: '実行中',
      metricRunningNote: '現在アクティブ',
      metricScheduling: 'スケジューリング',
      metricSchedulingNote: 'ポッド待ち',
      metricQueued: 'キュー待ち',
      metricQueuedNote: 'キャパシティ待ち',
      metricMax: '最大',
      metricMaxNote: '同時実行数',
      capacityTitle: 'キャパシティ',
      capacityAside: '{active} アクティブ / 最大 {max}',
      concurrencyUncapped: '同時実行数に上限はありません',
      concurrencyInUse: '設定された同時実行数のうち使用中',
      unlimitedSlots: '無制限のスロット',
      slotsAvailable: '{count} スロット利用可能',
      legendRunning: '{count} 実行中',
      legendScheduling: '{count} スケジューリング中',
      gitPolicyTitle: 'Git プロバイダーポリシー',
      giteaEnabled: 'Gitea 有効',
      giteaDisabled: 'Gitea 無効',
      giteaUrlLabel: 'Gitea URL',
      draftPrLabel: 'ドラフト PR 出力',
      draftPrAvailable: '認可された ID が利用可能',
      draftPrUnavailable: '利用不可 — diff のみ',
      allowedHostsLabel: '許可された Git ホスト',
      unrestricted: '制限なし',
      modelsConfigured_one: '{count} 件のカタログモデルが設定されています。',
      modelsConfigured_other: '{count} 件のカタログモデルが設定されています。',
      modelsManagedPrefix: 'モデルの認証情報とアカウントアクセスは ',
      modelsLink: 'モデル',
      modelsManagedSuffix: ' で管理されます。アカウントやリポジトリにプロバイダーキーが渡ることはありません。',
      guardrailsTitle: 'ガードレール',
      runTimeoutLabel: '実行タイムアウト',
      jobTtlLabel: 'ジョブ TTL',
      runnerTitle: 'ランナー',
      imageLabel: 'イメージ',
      launcherLabel: 'ランチャー',
      workspaceLabel: 'ワークスペース',
      persistent: '永続',
      ephemeral: '一時的',
      prewarmLabel: 'イメージ事前ダウンロード',
      prewarmUnsupported: 'Kubernetes ランチャーが必要です',
      prewarmNever: '未同期',
      prewarmReady: '{ready}/{desired} ノードにキャッシュ済み',
      prewarmLastSyncLabel: '最終同期',
      prewarmSync: '最新イメージを同期',
      prewarmSyncError: '同期に失敗しました — orchestrator のログを確認してください',
      buildTitle: 'ビルド',
      versionLabel: 'バージョン',
      commitLabel: 'コミット',
      usersLabel: 'ユーザー',
      coldArchiveUnavailable: 'コールドアーカイブは利用できません。',
    },
    models: {
      contextUnknown: 'コンテキスト不明',
      contextK: '{value}K コンテキスト',
      context: '{value} コンテキスト',
      eyebrow: 'Cluster カタログ',
      title: 'モデルプロバイダー',
      description: 'プロバイダーを一度接続して認証情報を封印し、モデルアクセスをアカウントに直接付与します。',
      addProvider: 'プロバイダーを追加',
      securityNote: 'プロバイダーキーは書き込み専用です。カタログは認証情報が設定されているかどうかのみを報告し、保存された値の一部を返すことはありません。',
      filterLabel: 'モデルまたはプロバイダーを絞り込み',
      filterPlaceholder: 'モデルまたはプロバイダーを絞り込み…',
      resultCount: '/ {total} モデル',
      configuredProviders: '設定済みプロバイダー',
      providersSummary: '{providers} プロバイダー · {accountGrants} アカウント付与',
      loadingProviders: 'モデルプロバイダーを読み込み中…',
      loadProvidersError: 'モデルプロバイダーを読み込めませんでした',
      noMatches: '一致するモデルまたはプロバイダーがありません。',
      noProviders: 'モデルプロバイダーが設定されていません。',
      noMatchesHint: 'プロバイダー名、モデル ID、または機能を試してください。',
      noProvidersHint: 'プロバイダーを追加して、Desktop とリポジトリ実行の両方でアカウントがモデルを利用できるようにします。',
      authServiceIdentity: 'サービス ID',
      authKeySet: 'キー設定済み',
      authKeyless: 'キーレス',
      authKeyMissing: 'キーなし',
      verifiedIn: 'プロバイダーを {ms} ms で検証しました。',
      reachableIn: 'プロバイダーに {ms} ms で到達しましたが、カタログは利用できません。',
      verifyError: 'プロバイダーを検証できませんでした。',
      removeConfirm: '{name} と設定済みのすべてのモデルを削除しますか？',
      providerRemoved: 'プロバイダーを削除しました。',
      removeError: 'プロバイダーを削除できませんでした。',
      customLabel: 'カスタム',
      credKeylessIdentity: 'キーレスワークロード ID',
      credConfigured: '認証情報設定済み',
      credNoneRequired: '認証情報不要',
      credRequired: '認証情報が必要',
      lastTest: '前回のテスト: {error}',
      verified: '検証済み',
      test: 'テスト',
      editProviderAria: '{name} プロバイダーを編集',
      removeProviderAria: '{name} プロバイダーを削除',
      customModel: 'カスタムモデル',
      configuredModel: '設定済みモデル',
      configuredModels: '設定済みモデル',
      catalogUnavailable: 'カタログ利用不可',
      browseCatalog: 'カタログを見る',
      customModelAction: 'カスタムモデル',
      limitNote: 'このエンドポイントはモデルカタログを公開していません。モデルは明示的に追加する必要があり、フォールバックカタログが代用されることはありません。',
      capabilitiesAria: 'モデルの機能',
      capReasoning: '推論',
      capTools: 'ツール',
      capImage: '画像',
      projectGrants_one: 'プロジェクト付与',
      projectGrants_other: 'プロジェクト付与',
      accountGrants_one: 'アカウント付与',
      accountGrants_other: 'アカウント付与',
      manageAccess: 'アクセスを管理',
      capabilitiesLegend: '機能',
      capToolUse: 'ツール使用',
      capImageInput: '画像入力',
      customValidationRequired: '表示名とモデル ID は必須です。',
      customValidationContext: 'コンテキストウィンドウはゼロまたは正の数である必要があります。',
      customAdded: 'カスタムモデルを追加しました。',
      addModelError: 'モデルを追加できませんでした。',
      customDialogTitle: 'カスタムモデル · {name}',
      addCustomModel: 'カスタムモデルを追加',
      displayNameLabel: '表示名',
      displayNamePlaceholder: '例: Coding Plan',
      modelIdLabel: 'モデル ID',
      modelIdHint: 'アップストリームの素のモデル ID。ランタイムのプロバイダープレフィックスはサーバー側で付加されます。',
      contextWindowLabel: 'コンテキストウィンドウ',
      modelAdded: '{name} を追加しました。',
      addCatalogError: 'カタログモデルを追加できませんでした。',
      syncMetadata: 'メタデータを同期',
      metadataSynced: '{name} のメタデータを同期しました。',
      syncMetadataError: 'モデルメタデータを同期できませんでした。',
      catalogDialogTitle: 'カタログ · {name}',
      loadingCatalog: 'プロバイダーカタログを読み込み中…',
      catalogLoadError: 'カタログを読み込めませんでした',
      catalogLoadFallback: 'プロバイダーカタログを読み込めませんでした。',
      grantUpdateError: 'プロジェクト付与を更新できませんでした。',
      accountGrantUpdateError: 'アカウントアクセスを更新できませんでした。',
      accessDialogTitle: 'モデルアクセス · {name}',
      accessIntro: 'アカウントへの 1 つの付与を Cloud と Desktop の両方で使用します。認証情報は Cluster 境界内に保持されます。',
      accessTabsAria: 'モデルアクセス範囲',
      accessAccounts: 'アカウント',
      accessProjects: 'プロジェクト',
      accountAccessIntro: '付与されたアカウントの Repository 実行とすべての Desktop がこのモデルを利用できます。',
      projectAccessIntro: '付与されたプロジェクトは Cloud 実行でこのモデルを選択できます。',
      accountSearchLabel: 'アカウントを検索',
      accountSearchPlaceholder: 'アカウントを検索…',
      loadingAccounts: 'アカウントを読み込み中…',
      noAccounts: '一致するアカウントがありません。',
      allDesktops: '現在および今後のすべての Desktop',
      allCloudAndDesktop: 'すべての Repository 実行と Desktop',
      clusterAdminAccount: 'Cluster 管理者 · すべての Desktop',
      loadingProjects: 'プロジェクトを読み込み中…',
      noProjects: 'プロジェクトはまだ存在しません。',
      servicesCount: '{count} サービス',
      providerValidationRequired: '名前、プロバイダータイプ、Base URL は必須です。',
      providerValidationKey: '新しい API キープロバイダーには API キーが必要です。',
      providerSaved: 'プロバイダーを保存しました。',
      saveProviderError: 'プロバイダーを保存できませんでした。',
      providerAdded: 'プロバイダーを追加しました。',
      addProviderError: 'プロバイダーを追加できませんでした。',
      editProviderTitle: 'プロバイダーを編集 · {name}',
      addProviderTitle: 'モデルプロバイダーを追加',
      saveProvider: 'プロバイダーを保存',
      providerSourceLabel: 'プロバイダーの種類',
      providerRegistryMode: 'プロバイダー',
      providerCustomMode: 'カスタム',
      providerSelectLabel: 'プロバイダー',
      providerSelectPlaceholder: 'プロバイダーを選択',
      providerNameLabel: 'プロバイダー名',
      providerNamePlaceholder: '例: Zhipu AI',
      providerTypeLabel: 'プロバイダータイプ',
      providerTypeHint: 'openai、qwen、zhipu などの小文字のランタイムプレフィックス。',
      baseUrlLabel: 'Base URL',
      authLabel: '認証',
      authApiKey: 'API キー',
      authServiceIdentityOption: 'サービス ID',
      authNone: '認証情報なし',
      rotateApiKeyLabel: 'API キーをローテーション',
      apiKeyPlaceholderKeep: '空欄のままにすると現在のキーを保持します',
      apiKeyPlaceholderEnter: 'プロバイダーキーを入力',
      apiKeyHint: '書き込み専用。保存された値を読み返すことはできません。',
      catalogLabel: 'モデルカタログ',
      catalogAuto: '/models から検出',
      catalogDisabled: '利用不可 — カスタムモデルのみ',
      advancedLabel: '詳細設定',
      headersHint: 'このプロバイダーへの各リクエストに付与されるカスタムヘッダー。値は書き込み専用です。',
      headersConfiguredHint: 'カスタムヘッダーが設定されています。行を追加して置き換えるか、空欄のままにすると保持します。',
      headerKeyPlaceholder: 'ヘッダー名',
      headerValuePlaceholder: '値',
      addHeader: 'ヘッダーを追加',
      removeHeader: 'ヘッダーを削除',
      headerValidation: '各ヘッダーには名前と値の両方が必要です。',
    },
    connections: {
      loading: 'Cluster 接続を読み込み中…',
      statusError: '接続ステータスを読み込めませんでした',
      configError: 'jtype 設定を読み込めませんでした',
      eyebrow: '外部システム',
      title: '接続',
      description: 'Cluster 全体のエンドポイントと ID プロバイダー。リポジトリ認可は各リポジトリ接続で管理されます。',
      configurationTabs: '接続設定',
      integrationsTab: 'インテグレーション設定',
      loginTab: 'ログイン設定',
      statusEyebrow: '有効な状態',
      statusTitle: '接続ステータス',
      statusDescription: 'Cluster が報告する読み取り専用の実行状態を、編集可能なプロバイダー設定と分けて表示します。',
      configuredCount: '{count} 件設定済み',
      gitPolicyTitle: 'Git プロバイダーポリシー',
      gitPolicySubtitle: '環境所有 · 読み取り専用',
      giteaEnabled: 'Gitea 有効',
      giteaDisabled: 'Gitea 無効',
      giteaUrlLabel: 'Gitea URL',
      clusterPatLabel: 'Cluster PAT',
      patConfigured: '設定済み · 値は非表示',
      allowedHostsLabel: '許可されたホスト',
      unrestricted: '制限なし',
      oobTitle: '変更はアウトオブバンドで行われます。',
      oobBody: 'プロバイダー URL、PAT、ホスト許可リストはデプロイ設定のままです。このページは有効な状態を報告します。',
      authTitle: '認証',
      registeredUsers: '{count} 人の登録ユーザー',
      oauthOn: 'OAuth オン',
      tokenOnly: 'トークンのみ',
      giteaOauthLabel: 'Gitea OAuth',
      githubOauthLabel: 'GitHub OAuth',
      consoleTokenLabel: 'コンソールトークン',
      consoleTokenValue: 'Cluster 管理者フォールバック',
      oauthSecurityNote: 'OAuth リダイレクト URI はプロバイダー UI で変更します。API パッチはクライアントシークレットをローテーションするためです。',
      githubUnavailableTitle: 'GitHub サインインは利用できません。',
      githubUnavailableBody: 'GitHub OAuth プロバイダーが設定されていません。プロバイダーが存在するまで、UI に動作する GitHub ボタンは表示されません。',
      providerHealth: {
        unknown: '未確認',
        healthy: '正常',
        partial: '基本接続は正常',
        error: 'エラー',
        incomplete: '設定が不完全',
      },
      providerHealthError: '接続確認に失敗しました：{message}',
      githubAppSetupIncomplete: 'GitHub App の設定が不完全です',
      instanceUrl: 'インスタンス URL',
      providerCapabilities: 'プロバイダー機能',
      loginEnabled: 'ログインを有効化',
      loginCapability: 'ログイン',
      loginCapabilityHint: 'このプロバイダーを Cloud サインインに使用できるようにします。',
      pluginEnabled: 'プラグインを有効化',
      pluginCapability: 'プラグイン',
      pluginCapabilityHint: 'リポジトリが接続して利用できるようにします。',
      oauthClientId: 'OAuth クライアント ID',
      oauthClientSecret: 'OAuth クライアントシークレット',
      configuredReplace: '設定済み — 入力して置き換え',
      enterSecret: 'シークレットを入力',
      githubAppId: 'GitHub App ID',
      githubAppPrivateKey: 'GitHub App 秘密鍵',
      configuredPemReplace: '設定済み — PEM を貼り付けて置き換え',
      pastePrivateKeyPem: '完全な秘密鍵 PEM を貼り付け',
      privateKeyHint: '書き込み専用です。Cloud は PEM を暗号化し、ブラウザーには返しません。',
      webhookSecret: 'Webhook シークレット',
      webhookSecretPlaceholder: 'GitHub に設定したものと同じシークレットを入力',
      githubAppConfigurationIncomplete: 'GitHub App の設定が不完全です',
      githubAppConfigurationIncompleteHint: 'アカウントが Installation を一覧できるよう、App ID、秘密鍵、および一致する Webhook シークレットを追加してください。',
      testConnection: '接続をテスト',
      jtypeSaved: 'jtype 接続を保存しました。',
      jtypeSaveError: 'jtype を保存できませんでした。',
      jtypeOverrideRemoved: 'jtype DB オーバーライドを削除しました。',
      jtypeRemoveError: 'オーバーライドを削除できませんでした。',
      sourceDb: 'DB オーバーライド',
      sourceEnv: '環境フォールバック',
      sourceNone: '未設定',
      jtypeKanban: 'jtype Kanban',
      pollingEvery: '{interval} ごとにポーリング',
      jtypeEffective: '有効',
      jtypeBroken: '破損',
      jtypeOff: 'オフ',
      baseUrlLabel: 'Base URL',
      baseUrlHint: 'このクラスターが接続する jtype インスタンス。Kanban 認証情報は各プロジェクト所有者がリンクごとに管理します。',
      boardTrafficNote: 'ボードトラフィックはサーバープロキシを経由します。jtype トークンがブラウザに入ることはありません。',
      jtypeUnavailableTitle: 'jtype 設定は利用できません。',
      removeOverride: 'オーバーライドを削除',
      saveJtype: 'jtype を保存',
      archiveTitle: 'ワークスペースアーカイブ',
      archiveSubtitle: '永続ワークスペースのコールドストレージ',
      archiveEnabled: '有効',
      archiveUnavailable: '利用不可',
      endpointLabel: 'エンドポイント',
      bucketLabel: 'バケット',
      idleWindowLabel: 'アイドル期間',
      idleDays: '{count} 日',
      archiveDisabledTitle: '長期アーカイブは有効になっていません。',
      archiveDisabledReason: 'オブジェクトストレージが設定されていません。',
    },
    system: {
      forbiddenTitle: 'Cluster ビューは Cluster 管理者専用です',
      forbiddenDescription: 'このロールはプロジェクトのみを管理します。キャパシティ、ガードレール、プロバイダーの詳細については Cluster 管理者にお問い合わせください。',
      title: 'Cluster',
      subtitle: 'このオーケストレーターのスナップショット: キャパシティ、ガードレール、構成。モデルはここで設定します。その他の変更はアウトオブバンド（env / kubectl）で行います。',
      loadingSnapshot: 'Cluster スナップショットを読み込み中…',
      snapshotError: 'Cluster スナップショットを読み込めませんでした',
      noSnapshotTitle: 'スナップショットなし',
      noSnapshotDescription: 'オーケストレーターはシステム情報を返しませんでした。',
      capacityTitle: 'キャパシティ',
      unlimitedConcurrency: '無制限の同時実行',
      activeMax: '{active} アクティブ / 最大 {max}',
      capacityBarAria: '最大同時実行数に対するアクティブな実行',
      statRunning: '実行中',
      statScheduling: 'スケジューリング',
      statQueued: 'キュー待ち',
      statMaxConcurrent: '最大同時実行数',
      guardrailsTitle: 'ガードレール',
      runTimeoutLabel: '実行タイムアウト',
      jobTtlLabel: 'ジョブ TTL',
      providerTitle: 'プロバイダー',
      giteaEnabled: 'Gitea 有効',
      giteaDisabled: 'Gitea 無効',
      draftPrsLabel: 'ドラフト PR',
      on: 'オン',
      offDiffOnly: 'オフ（diff のみ）',
      giteaUrlLabel: 'Gitea URL',
      allowedHostsLabel: '許可された git ホスト',
      unrestrictedAnyHost: '制限なし（任意のホスト）',
      allowedHostsHint: 'プロジェクト連携はこれらのホストのみを対象にできます（ALLOWED_GIT_HOSTS）。空 = 任意のホスト。',
      runnerTitle: 'ランナー',
      imageLabel: 'イメージ',
      namespaceLabel: 'ネームスペース',
      launcherLabel: 'ランチャー',
      persistentWorkspaceLabel: '永続ワークスペース',
      off: 'オフ',
      authTitle: '認証',
      providerCount_one: '{count} プロバイダー',
      providerCount_other: '{count} プロバイダー',
      tokenOnly: 'トークンのみ',
      oauthProvidersLabel: 'OAuth プロバイダー',
      noneConsoleToken: 'なし（コンソールトークンのみ）',
      usersLabel: 'ユーザー',
      versionTitle: 'バージョン',
      orchestratorLabel: 'オーケストレーター',
      commitLabel: 'コミット',
      modelCatalogTitle: 'モデルカタログ',
      modelCount_one: '{count} モデル',
      modelCount_other: '{count} モデル',
      noModels: 'モデルなし',
      modelCatalogHint: 'OpenAI 互換エンドポイントを登録し、プロジェクトごとに認可します。付与されたモデルが 1 つ以上あるまで、プロジェクトの実行はブロックされます。',
      loadingModelCatalog: 'モデルカタログを読み込み中…',
      modelCatalogError: 'モデルカタログを読み込めませんでした',
      noModelsYet: 'モデルはまだありません — 下から追加してください。',
      keySet: 'キー設定済み',
      keyless: 'キーレス',
      modelSaved: 'モデルを保存しました。',
      modelSaveError: 'モデルを保存できませんでした。',
      modelRemoved: 'モデルを削除しました。',
      modelRemoveError: 'モデルを削除できませんでした。',
      nameLabel: '名前',
      baseUrlLabel: 'Base URL',
      modelProviderLabel: 'モデル（プロバイダー/モデル）',
      apiKeyLabel: 'API キー',
      apiKeyPlaceholderClear: 'クリアされます（キーレス）',
      apiKeyPlaceholderRotate: '•••••••• （空欄 = 変更なし。入力するとローテーション）',
      apiKeyPlaceholderNew: 'sk-…  （キーレスの場合は空欄）',
      apiKeyHint: '暗号化して保存されます。保存後は表示されません。',
      clearKeyLabel: 'キーをクリア（このエンドポイントをキーレスにする）',
      noProjectsToAuthorize: '認可するプロジェクトはまだありません。',
      authorizedProjects: '認可済みプロジェクト',
      grantUpdateError: '付与を更新できませんでした。',
      modelAdded: 'モデルを追加しました。',
      modelAddError: 'モデルを追加できませんでした。',
      apiKeyPlaceholderAdd: 'sk-…  （キーレスエンドポイントの場合は空欄）',
      addModel: 'モデルを追加',
    },
  },

  app: {
    linked: '{provider} アカウントをリンクしました。',
    linkTaken: 'そのアカウントはすでに別のユーザーにリンクされています。',
    linkError: 'そのアカウントをリンクできませんでした。',
    auth: {
      loginProviderDenied: 'プロバイダーがサインインリクエストを拒否しました。再試行してください。',
      loginExchangeFailed: 'サインインを完了できませんでした（トークン交換に失敗）。',
      loginProfileFailed: 'サインイン時にプロバイダーからプロフィールを読み取れませんでした。',
      loginServerMisconfigured: 'サーバーでサインインが設定されていません。',
      loginServerError: 'サーバーがサインインの完了中にエラーが発生しました。',
      loginFailed: 'サインインに失敗しました。もう一度お試しください。',
      enterToken: 'コンソールトークンを入力してください。',
      superseded: '置き換えられました。',
      tokenRejected: 'オーケストレーターによってトークンが拒否されました。',
      lostOrchestrator: 'オーケストレーターとの接続が失われました — セットアップ手順を参照してください。',
    },
  },

  components: {
    modelGate: {
      unverified: 'モデルのステータスを検証できませんでした — 利用可能なモデルがない場合、実行が失敗する可能性があります。',
      notConfigured: 'このプロジェクトで利用可能なモデルがないため、実行を開始できません。',
      grantLink: 'Cluster ページでモデルを付与',
      contactAdmin: 'このプロジェクトにモデルを付与するには Cluster 管理者にお問い合わせください。',
    },
    prPanel: {
      stateOpen: 'オープン',
      stateMerged: 'マージ済み',
      stateClosed: 'クローズ済み',
      stateUnknown: '不明',
      stateAria: 'プルリクエストの状態: {state}',
      reviewRequested: 'AI レビューをリクエストしました。',
      reviewError: 'レビューをリクエストできませんでした。',
      loading: 'プルリクエストを読み込み中…',
      loadError: 'プルリクエストを読み込めませんでした',
      noPr: 'プルリクエストはまだ開かれていません。',
      requestReview: 'AI レビューをリクエスト',
      reviewsTitle: 'レビュー',
      reviewsEmpty: 'AI レビューはまだありません。',
      hide: '非表示',
      show: '表示',
      reviewFailed: 'レビュー実行は出力を生成する前に失敗しました。',
      reviewInProgress: 'レビュー進行中…',
    },
    states: {
      cannotReach: 'オーケストレーターに接続できません。実行されていますか？',
      somethingWrong: '問題が発生しました。',
      failedToLoad: '読み込みに失敗しました',
    },
    statusBadge: {
      queued: 'キュー待ち',
      scheduling: 'スケジューリング',
      running: '実行中',
      awaitingInput: '入力待ち',
      succeeded: '成功',
      failed: '失敗',
      canceled: 'キャンセル済み',
      blocked: 'ブロック中',
      aria: 'ステータス: {status}',
    },
    gitMode: {
      legend: 'Git 連携',
      modeAria: 'Git 連携モード',
      readonlyLabel: '読み取り専用 diff',
      readonlyHint: '実行が成功すると diff アーティファクトのみが生成され、プッシュは行われません。',
      draftPrLabel: 'ドラフト PR',
      draftPrHint: '成功するとエージェントはブランチをプッシュし、レビュー用のドラフト PR を開きます。自動マージや CI のトリガーは行いません。',
      draftPrTitle: '成功した実行はブランチをプッシュし、レビュー用のドラフト PR を開きます。',
      readonlyTitle: '成功した実行は diff アーティファクトのみを生成し、プッシュは行われません。',
    },
    identity: {
      roleClusterAdmin: 'Cluster 管理者',
      roleProjectAdmin: 'リポジトリ管理者',
      signOut: 'サインアウト',
      serviceNote: 'コンソールトークンで認証されています — リンクされた ID はありません。',
      session: 'セッション',
      linkedAccounts: 'リンク済みアカウント',
      noLinkedAccounts: 'リンク済みアカウントはまだありません。',
      linkAnother: '別のアカウントをリンク',
      link: '{name} をリンク',
    },
    kanbanConnect: {
      startError: '接続フローを開始できませんでした。',
      connect: 'jtype で接続',
      enterCode: '認可するには、このコードを jtype に入力してください:',
      openJtype: 'jtype を開いて認可',
      waiting: 'jtype での認可を待っています…',
      connected: '接続済み — トークン設定済み',
      failed: '接続に失敗しました — もう一度 Connect をクリックしてください。',
      expired: '接続の有効期限が切れました — もう一度 Connect をクリックしてください。',
      unsupported: 'この jtype デプロイはワンクリック Connect をサポートしていません — 代わりにトークンを貼り付けてください。',
      expiryExpired: '期限切れ',
      expiresInDays_one: '{count} 日後に期限切れ',
      expiresInDays_other: '{count} 日後に期限切れ',
    },
    projectSwitcher: {
      allProjects: 'すべてのプロジェクト',
      noProjects: 'プロジェクトはまだありません',
    },
    modal: {
      close: 'ダイアログを閉じる',
    },
  },


  members: {
    addedAs: '{name} を {role} として追加しました。',
    addError: 'メンバーを追加できませんでした。',
    updateRoleError: 'ロールを更新できませんでした。',
    removed: '{name} を削除しました。',
    removeError: 'メンバーを削除できませんでした。',
    searchPlaceholder: '名前で人を検索…',
    searchAria: '追加する人を検索',
    searching: '検索中…',
    noMatches: '一致する人がいません。',
    adminTag: '管理者',
    roleForAddedAria: '追加するメンバーのロール',
    roleForAria: '{name} のロール',
    removeAria: '{name} を削除',
    loading: 'メンバーを読み込み中…',
    loadError: 'メンバーを読み込めませんでした',
    roleOwner: 'オーナー',
    roleMember: 'メンバー',
    roleViewer: '閲覧者',
  },


  kanban: {
    enableTitle: 'Agent Board を接続',
    enableBody: '既存の Board、実行モデル、開始・作業中・任意の完了列を選択します。',
    pluginRequired: '先に JType を接続してワークスペースを選び、Agent Board を追加してください。',
    loadingAccountModels: 'アカウントモデルを読み込み中…',
    accountModelsUnavailable: 'アカウントモデルを読み込めませんでした。',
    accountModelRequired: 'Agent Board を有効にする前に、このアカウントへモデルを 1 つ以上許可してください。',
    loadingBoards: 'ボードを読み込み中…',
    boardsUnavailable: 'ボードを読み込めませんでした。JType プラグイン接続を確認してください。',
    enable: 'Agent Board を接続',
    disable: '切断',
    triggerColumn: '開始列',
	workColumn: '作業中の列',
    doneColumn: '完了列',
    noDoneColumn: '完了後にカードを移動しない',
    columnSettings: '自動化列',
    columnSettingsHint: 'カードがタスクを開始する列と、完了後の移動先をインラインで編集します。',
    columnsUnavailable: '列を読み込めませんでした。JType プラグイン接続を確認してください。',
    notConfiguredTitle: 'Kanban が設定されていません',
    notConfiguredMsg: 'このボードを開く前に、Cluster 管理者が jtype 連携を設定する必要があります。',
    tlsInvalidTitle: 'JType の証明書に修復が必要です',
    tlsInvalidMsg: 'JType の HTTPS 証明書を検証できません。管理者に証明書の更新または修復を依頼し、再試行してください。',
    unavailableTitle: 'Kanban は利用できません',
    unavailableMsg: 'jtype サービスに接続できませんでした。サービスが利用可能になったら再試行してください。',
    unauthorizedTitle: 'Kanban アクセスに対応が必要です',
    unauthorizedMsg: '現在の JType 接続ではこの Board を読み取れません。Repository owner または Cluster 管理者が接続を修復する必要があります。',
    workspaceNotFoundTitle: 'Kanban ワークスペースが見つかりませんでした',
    workspaceNotFoundMsg: 'この Agent Board は利用できなくなった JType ワークスペースを指しています。',
    boardNotFoundTitle: 'このボードを開けませんでした',
    boardNotFoundMsg: 'ボードが削除または名前変更されたか、連携がアクセスを失った可能性があります。',
    boardOpenDefaultMsg: '現在 Board を開けません。再試行するか、Repository owner に接続の確認を依頼してください。',
    title: 'Agent Board',
    boardLabel: 'ボード',
    openingBoard: 'ボードを開いています…',
    loadingPolicy: '実行ポリシーを読み込み中…',
    policyUnavailable: '実行ポリシーを読み込めませんでした。',
    policyTrigger: 'Card が {column} に入ると jcode を開始',
	policyWork: '受け付けた Card を {column} に移動',
	policyWorkMissing: '受け付けた Card は WIP に移動しません',
    policyWriteback: '成功時にコメントして {column} へ移動',
    policyCommentOnly: '結果を Card コメントに書き戻す',
    policyReady: '実行可能',
    policyBlocked: 'ブロック中 · {blocker}',
    policyBlockers: {
      binding_disabled: '自動化が無効',
      plugin_unavailable: 'JType 接続が利用不可',
      event_feed_unavailable: 'JType イベントフィードが利用不可',
      bootstrap_unavailable: 'JType カードの初期化が利用不可',
      card_index_unavailable: 'JType カードインデックスが利用不可',
      card_read_unavailable: 'JType カードを一時的に読み取れません',
      card_unavailable: 'JType カードが利用不可',
      board_validation_unavailable: 'JType ボードを検証できません',
      board_drift: 'ボードまたは自動化の列が変更されました',
      repository_not_configured: 'リポジトリ未設定',
      repository_unavailable: 'リポジトリ接続が利用不可',
      provider_unavailable: 'リポジトリ Provider が利用不可',
      runner_unavailable: 'Runner が利用不可',
      run_unavailable: 'リンクされた Cloud Run が利用不可',
      model_not_configured: 'モデル未設定',
      model_not_authorized: '実行アカウントにモデルが許可されていません',
      model_authorization_unavailable: 'モデル認可を確認できません',
      execution_account_not_owner: '実行アカウントが Repository owner ではありません',
      work_column_not_configured: '作業中の列が未設定です',
      model_effort_unsupported: '選択した推論強度は未対応',
    },
    executionsTitle: 'Cloud 実行',
    loadingExecutions: 'Cloud 実行を読み込み中…',
    executionsUnavailable: 'Cloud 実行履歴を読み込めませんでした。',
    noExecutions: 'Cloud 実行はまだありません。この Card を「jcode を開始」列に移動すると要求できます。',
    runWithAgent: 'Agent で実行',
    agentRunActive: 'Agent を実行中',
    rerunDoneConfirm: 'この Card は Done 列にあります。もう一度実行して作業中の列へ戻しますか？',
    executionState: {
      received: '要求を受信',
      blocked: 'ブロック中',
      queued: '待機中',
      running: '実行中',
      terminal: '終了',
      succeeded: '成功',
      failed: '失敗',
      canceled: 'キャンセル済み',
    },
    requestedByExternal: '要求者: {actor}',
    projectOwner: 'プロジェクト所有者',
    repositoryOwner: 'リポジトリ所有者',
    clusterAdmin: 'Cluster 管理者',
    openRun: 'Run を開く',
    writebackPending: 'Card への書き戻し待ち',
    writebackUnavailable: '元の Card は利用不可',
    executionSummary: {
      received: 'Card の要求を受信しました。',
      queued: 'Run は待機中です。',
      running: 'Run は要求された変更を実行中です。',
      succeeded: 'Run は正常に完了しました。',
      failed: 'Run は失敗しました。',
      canceled: 'Run はキャンセルされました。',
    },
    priorExecutions_one: '過去の実行 {count} 件',
    priorExecutions_other: '過去の実行 {count} 件',
    cardUnavailable: 'この Card は JType に存在しません。Cloud の実行履歴は保持されています。',
    loadEarlierExecutions: '以前の実行を読み込む',
    linkDisabledTitle: 'この Kanban 自動化リンクは無効化されています。',
    linkDisabledBody: 'ボードは表示できますが、カードトリガー実行と書き戻しは無効化されています。',
  },

  onboarding: {
    setupStep1: '4 つのローカルイメージをビルドする',
    setupStep2: 'OrbStack クラスターにデプロイし、ロールアウトを待つ',
    setupStep3: 'オーケストレーター API を localhost:8080 に転送する',
    probingEyebrow: '接続中',
    probingTitle: 'ランタイムを利用可能にする。',
    probingStory: 'コンソールは、認証されたワークフローを開始できるかどうかを確認しています。',
    probingUtility: '接続セットアップ',
    probingStatus: 'プロービング中',
    setupEyebrow: 'ローカルセットアップ',
    setupTitle: 'ランタイムを利用可能にする。',
    setupStory: 'コンソールの準備は完了しました。オーケストレーターがまだ応答していないため、認証されたワークフローを開始できません。',
    setupUtility: '接続セットアップ',
    setupStatus: '到達不可',
    signinEyebrow: 'あなたのコード。あなたの Cluster。',
    signinTitle: '作業をシステムの近くに保つ。',
    signinStory: 'jcode Cloud は、チームがすでに管理しているインフラにコーディングタスクをディスパッチします。',
    signinUtility: 'セキュアエントリー',
    signinStatus: 'サインイン',
    welcomeEyebrow: 'ワークスペース準備完了',
    welcomeTitle: '最初の境界はあなたが設定します。',
    welcomeStory: 'あなたが最初にサインインしました。jcode Cloud はこの ID に Cluster 管理者ロールを割り当てました。',
    welcomeUtility: '初回ユーザーセットアップ',
    welcomeStatus: 'サインイン済み',
    landingEyebrow: 'セッション準備完了',
    landingTitle: 'コントロールプレーンに手が届きます。',
    landingStory: 'コンソールトークンがこのブラウザに Cluster 管理者セッションを確立しました。',
    landingUtility: 'セッション境界',
    landingStatus: '認証済み',
    selfHosted: 'セルフホスト',
    assignedRole: '割り当てられたロール',
    clusterAdministrator: 'Cluster 管理者',
    adminSeparate: 'Cluster 管理はリポジトリの所有権とは別です。',
    roleManageGrants: 'モデル付与を管理',
    roleConfigureConnections: '接続を設定',
    roleViewCapacity: 'キャパシティとポリシーを表示',
    sessionBoundary: 'セッション境界',
    whatSignInEstablishes: 'サインインが確立するもの',
    signInEstablishesBody: 'オーケストレーターはプロバイダー ID を 1 つの jcode Cloud アカウントにマッピングします。リポジトリ所有権とプロバイダーアクセスは個別に評価されます。',
    providerTokensServerSide: 'プロバイダートークンはサーバー側に留まり、このページに描画されることはありません。',
    currentProbe: '現在のプローブ',
    whatConsoleKnows: 'コンソールが把握していること',
    probeBody: 'この状態は到達可能性のみを報告します。Kubernetes、イメージ、認証情報が正常かどうかを推測するものではありません。',
    probeTarget: 'ターゲット',
    probeResponse: 'レスポンス',
    probeUnreachable: '到達不可',
    probeWaiting: '待機中',
    cantReachTitle: 'オーケストレーターに接続できません',
    setupLede1: 'コンソールは ',
    setupLede2: ' を ',
    setupLede3: ' にプロキシしますが、応答がありませんでした。スタックを起動すれば、このページは自動的に次に進みます。',
    recheckingNote: '3 秒ごとに再確認中 — 更新は不要です',
    checkNow: '今すぐ確認',
    reasonRejected: '保存されたトークンが拒否されました — ローテーションされた可能性があります。現在のものを入力してください。',
    reasonExpired: 'セッションが終了しました（期限切れまたは取り消し）。もう一度サインインしてください。',
    reasonSignedOut: 'サインアウトしました。',
    continueWith: '{name} で続行',
    signInHeading: 'サインイン',
    signInLedeNoProviders: 'OAuth プロバイダーが設定されていません。オーケストレーターのデプロイ時に使用したコンソールトークンを使用してください。',
    signInLedeProviders: 'git プロバイダーで続行して、ユーザーごとの個人セッションを取得します。',
    advancedConsoleToken: '詳細: コンソールトークン',
    consoleTokenLabel: 'コンソールトークン',
    consoleTokenHint: 'オーケストレーターのデプロイ時に使用した CONSOLE_TOKEN — Cluster 管理者。このブラウザにローカル保存されます。',
    signInWithToken: 'トークンでサインイン',
    welcomeFirstAdminTitle: 'あなたは最初のユーザーです — Cluster 管理者',
    welcomeGreeting: 'ようこそ、{name} さん',
    welcomeFirstAdminLede: 'あなたが最初にサインインしたため、現在 Cluster 管理者です: すべてのプロジェクトを表示し、キャパシティを管理できます。あなたの後に参加する全員は通常ユーザーとして開始します。',
    welcomeLede: 'サインインしました。プロジェクトを作成して jcode Cloud をリポジトリに向けるか、追加されたプロジェクトを開いてください。',
    friend: 'ゲスト',
    signedInAs: '{name} としてサインイン済み',
    getStarted: '始める',
    landingCardTitle: '参加しました — Cluster 管理者',
    landingLede: 'このオーケストレーターにサインイン済み:',
    principal: 'プリンシパル',
    access: 'アクセス',
    accessClusterAdmin: 'Cluster 管理者',
    accessMember: 'メンバー',
    session: 'セッション',
    sessionConsoleToken: 'コンソールトークン',
    sessionUser: 'ユーザーセッション',
    identity: 'ID',
    everythingHeadless: 'すべてが Cluster 内でヘッドレスに実行されます。',
    enterConsole: 'コンソールに入る',
    connecting: 'オーケストレーターに接続中…',
    mobileHandoff: 'スマホでサインインを完了しています…',
    mobileConsentTitle: 'スマホでサインイン',
    mobileConsentLede: '{name} としてサインイン済みです。下のボタンをタップしてモバイルアプリのサインインを完了してください。',
    mobileConsentContinue: 'アプリへ進む',
  },

  notFound: {
    title: 'このパスはここで終わります。',
    body: 'ページが移動したか、リンクがアクセスできなくなったリポジトリまたはタスクを示している可能性があります。',
    backToProjects: 'リポジトリに戻る',
  },

  device: {
    compose: {
      project: '作業ディレクトリ',
      model: 'モデル',
      effort: '強度',
      goal: 'ゴール',
      goalPlaceholder: 'このセッションで達成したいことは？',
      attachments: '添付ファイル',
      attachAdd: 'ファイルを添付',
      removeAttachment: '{name} を削除',
      deviceDefault: 'デバイスのデフォルト',
      attachmentTooBig: '{name} は 2 MB を超えています。小さいファイルを選んでください。',
      attachmentTooMany: '添付ファイルは 1 メッセージにつき最大 {max} 件です。',
      attachmentImage: '{name} は画像です — 画像はまだサポートされていません。',
    },
    composer: {
      placeholder: 'jcode への指示を入力、/ でコマンド',
      goalPlaceholder: 'ゴールを記述 — 検証可能な完了までエージェントが追求します',
      queuePlaceholder: 'エージェント実行中 — 入力でフォローアップをキュー…',
      attachedImages: '（添付画像を参照）',
      send: '送信',
      queue: 'キュー',
      stop: '停止',
      stopAgent: 'エージェントを停止 (Esc)',
      stopAndNext: '現在のターンを停止して次のキューメッセージを送信',
      removeQueued: 'キューから削除',
      add: '追加',
      attachFiles: 'ファイルを添付',
      command: 'コマンド',
      goal: 'ゴール',
      workflowBadge: 'ワークフロー',
      goalSlashDesc: 'ゴールモードを有効化 — 次のメッセージが目標になります',
      goalHintNext: '次のメッセージがセッションのゴールになります',
      goalHintNextReplaces: '次のメッセージで現在のゴールを置き換えます',
      goalHintRemove: 'ゴールを解除',
      goalHintReplace: '新しいゴールを設定すると現在のゴールが置き換わります',
      modelNoImages: '現在のモデルは画像に対応していません',
      modeApproval: '都度確認',
      modeApprovalSub: '書き込みやコマンド実行の前に毎回確認します。',
      modePlan: 'プラン',
      modePlanSub: 'まず計画を提示。承認されるまで何も実行しません。',
      modeAuto: '自動',
      modeAutoSub: 'AI レビュアーが安全なツールを許可。不確かなものは確認します。',
      modeFullAccess: 'フルアクセス',
      modeFullAccessSub: '自由に実行 — 承認プロンプトなし。',
      modeCeilingHint: 'クラウドセッションは Auto モードまで利用できます。',
      modelFilter: 'モデルを絞り込み…',
      modelCurrent: '現在',
      modelFavorites: '★ お気に入り',
      modelReasoning: '推論',
      modelTools: 'ツール呼出',
      modelImages: '画像入力',
      modelNoImageInput: '現在のモデルは画像入力に対応していません',
      modelNone: '利用可能なモデルがありません',
      modelNoMatch: '条件に合うモデルがありません。',
      modelManage: 'モデルを管理…',
      modelManageTitle: 'モデル管理',
      modelToggleVisibility: 'セレクターに表示するモデルを切り替え',
      modelVisibleCount: 'セレクターに {visible}/{total} 件のモデルを表示中',
      effort: '推論強度',
      effortTitle: 'このモデルの推論強度',
      effortDefault: 'デフォルト',
      contextTitle: 'コンテキスト容量',
      contextSystemPrompt: 'システムプロンプト',
      contextSystemTools: 'システムツール',
      contextMcpTools: 'MCP ツール',
      contextSkills: 'スキル',
      contextMessages: 'メッセージ',
      contextInput: '入力',
      contextOutput: '出力',
      contextCached: 'キャッシュ',
      contextReasoning: '推論',
      contextCacheHitRate: 'キャッシュヒット率',
      workspaceNone: 'フォルダーを選択',
      workspaceUnavailable: '現在のフォルダーを取得できません。再試行するかフォルダーを選択してください。Chat にはデバイスの jcode 更新が必要です。',
      workspaceNewConversation: 'デバイスのページに戻って新しい会話を作成してください。',
      workspaceNonePlural: 'ワークスペースなし',
      workspaceSearch: 'ワークスペースを検索',
      workspaceLoading: '読み込み中…',
      workspaceNoFolders: 'フォルダなし',
      workspaceOpen: '開く',
      workspaceOpenFolder: 'フォルダを開く',
      workspaceOpenError: 'ワークスペースを開けませんでした',
      workspacePathPlaceholder: 'デバイス上のパス',
      remoteConnect: 'リモート接続',
      branchesTitle: 'ブランチ',
      branchesNone: 'ブランチなし',
      branchSearch: 'ブランチを検索',
      branchCreate: '新規ブランチを作成して切替',
      branchCreateBtn: '作成',
      branchNewName: 'new-branch-name',
      branchCurrent: 'ブランチ: {name}',
      branchConfirmTitle: '未コミットの変更',
      branchConfirmIntro: '"{branch}" へ切り替えると以下のローカルファイルが上書きされます:',
      branchConfirmMore: '他 {count} 件',
      branchConfirmStash: 'スタッシュして切替',
      branchConfirmDiscard: '破棄して切替',
      branchConfirmCancel: 'キャンセル',
      branchConfirmHint: 'スタッシュは git stash pop で復元できます。破棄は未追跡ファイルを含め完全に削除します。',
      branchSwitchError: 'ブランチの切替に失敗しました',
      goalStatusActive: 'アクティブ',
      goalStatusCompleted: '完了',
      goalStatusBlocked: 'ブロック',
      goalStarted: '開始',
      goalElapsed: '経過',
      goalEdit: '編集',
      goalEditTitle: 'ゴールを編集',
      goalClear: 'ゴールをクリア',
      goalSaveFailed: 'ゴールを保存できませんでした',
      goalTokens: '{used} tokens',
      goalTokensK: '{k}k tokens',
      durationSeconds: '{n}秒',
      durationMinutes: '{m}分{s}秒',
      durationHours: '{h}時間{m}分',
      commonTokens: '{used} tokens',
      commonLoading: '読み込み中…',
      commonClose: '閉じる',
      commonCancel: 'キャンセル',
      commonSave: '保存',
      commonDone: '完了',
      commonEnable: '有効化',
      commonDisable: '無効化',
      commonRecommended: 'おすすめ',
    },
    list: {
      title: 'デバイス',
      subtitle: 'アカウントに接続されている jcode デバイス。オンラインのマシンに作業を送信できます。',
      emptyTitle: 'デバイスがまだありません',
      emptyBody: 'マシン上で `jcode login` を実行して、jcode Cloud に接続してください。',
      online: 'オンライン',
      offline: 'オフライン',
      lastSeen: '最終確認 {time}',
      neverSeen: '未接続',
      loadErrorTitle: 'デバイスを読み込めませんでした',
      servicePrincipal: 'デバイスはユーザーアカウントに紐づいています。コンソールのサービストークンではなく、ユーザーセッションでサインインしてください。',
      platformDesktop: 'デスクトップ',
      platformCli: 'CLI',
      e2ee: 'エンドツーエンド暗号化',
      e2eeWithKeyGen: 'エンドツーエンド暗号化 · キー世代 {gen}',
    },
    welcome: {
      back: 'デバイス',
      newSession: '新しいセッション',
      composerPlaceholder: 'jcode に何でも聞いてください…',
      send: '送信',
      mode: 'モード',
      sessions: 'セッション',
      sessionCount_one: '{count} 件のセッション',
      sessionCount_other: '{count} 件のセッション',
      noSessions: 'セッションがまだありません。メッセージを送信して開始してください。',
      creating: 'セッションを作成しています…',
      createSlow: 'デバイスの応答が遅れています——まもなくセッションが表示されます。',
      untitled: '無題のセッション',
      offlineBanner: 'このデバイスはオフラインです。再接続されるまでメッセージを送信できません。',
      delete: 'デバイスを削除',
      deleteConfirm: '{name} を削除しますか？デバイスはサインアウトされ、同期が停止します。セッション履歴はサーバーに保持されます。',
      deleted: 'デバイス {name} を削除しました',
      sessionDelete: 'セッションを削除',
      sessionDeleteRunning: '削除する前にセッションを停止してください',
      sessionDeleteConfirm: '「{name}」をデスクトップとクラウドから削除しますか？',
      sessionDeleted: 'セッション「{name}」を削除しました',
      status: {
        idle: 'アイドル',
        running: '実行中',
      },
    },
    session: {
      back: 'デバイスに戻る',
      thinking: '考え中',
      thinkingAria: '考え中…',
      you: 'あなた',
      send: '送信',
      stop: '停止',
      composerPlaceholder: 'jcode へのメッセージ…',
      offlineBanner: 'デバイスがオフラインです。再接続されるまで送信は無効です。',
      streamError: 'ライブストリームが中断されました。再接続しています…',
      reconnect: '再接続',
      approve: '承認',
      approveAll: '常に許可',
      deny: '拒否',
      toolDenied: '拒否されました',
      askUser: 'jcode から質問があります（デバイス上で回答してください）:',
      agentStarted: 'エージェントが開始しました',
      agentDone: 'エージェントが完了しました',
      agentStopped: 'ユーザーによって停止されました',
      agentFailed: 'エージェントが失敗しました: {message}',
      taskRunning: 'セッション実行中',
      taskIdle: 'セッションはアイドルです',
      modeChanged: 'モードが {mode} に変更されました',
      modelChanged: 'モデルが {model} に変更されました',
      sessionReset: 'セッションがリセットされました',
      todoUpdated: 'Todo が更新されました',
      goalUpdated: 'ゴールが更新されました: {objective}',
      goalCleared: 'ゴールがクリアされました',
      subagentStarted: 'サブエージェント {name} が開始しました',
      subagentDone: 'サブエージェント {name} が完了しました',
      subagentFailed: 'サブエージェント {name} が失敗しました',
      sendFailed: '送信できませんでした: {message}',
      deviceOffline: 'デバイスはオフラインです',
      emptyHistory: 'このセッションにはまだイベントがありません。',
      source: {
        console: 'コンソール',
        mobile: 'モバイル',
        desktop: 'デスクトップ',
        wechat: 'WeChat',
        local: 'ローカル',
      },
    },
    guide: {
      entry: '利用ガイド',
      title: 'jcode デバイスの使い方',
      subtitle: '`jcode login` でマシンを接続し、ブラウザやモバイルアプリから操作する方法。',
      back: 'デバイス一覧に戻る',
      shots: {
        devices: 'クラウドコンソールのデバイス一覧',
        welcome: 'デバイスページ：新しいセッションの開始と既存セッションの参照',
        session: 'デバイスからライブ配信されるセッション',
        offline: 'オフラインのデバイスでも履歴を表示',
        login: 'モバイルアプリのサインイン画面',
      },
      what: {
        title: '「デバイス」とは？',
        p1: 'デバイスとは、jcode（CLI またはデスクトップ）を実行し、`jcode login` で jcode Cloud にサインインしたマシンのことです。接続後は、クラウドコンソールやモバイルアプリからそのマシンをリモートで表示・操作できます。',
        p2: 'クラウドはトラフィックを中継するだけです。マシン側からクラウドへ外向きに接続するため、受信ポートや VPN は不要です。セッションは常にマシン上で実行・保存されます。',
      },
      quickstart: {
        title: 'クイックスタート',
        p1: '操作したいマシンで次を実行します：',
        code1: 'jcode login',
        p2: 'CLI がコードと確認リンクを表示します。ブラウザでサインインを承認してください。その後デバイスは自動的に接続され、デバイス一覧に表示されます。',
        p3: 'デフォルトでは https://cloud.j-code.net にサインインします。セルフホストの場合は URL を指定してください。https が必須です（平文 http は開発時の localhost のみ許可）：',
        code2: 'jcode login --cloud https://your-cloud.example.com',
      },
      remote: {
        title: 'デバイスのリモート操作',
        p1: 'デバイス一覧を開き、デバイスを選択します。新しいセッションの開始、実行中セッションのライブ表示、実行の停止、承認プロンプトへの応答など、マシン本体と同じ操作ができます。',
        p2: 'デバイスがオフラインのときもセッション履歴は読めますが、メッセージ送信と承認は再接続されるまで無効になります。',
      },
      pairing: {
        title: 'ペアリングとエンドツーエンド暗号',
        p1: 'セッション内容はエンドツーエンドで暗号化されています。クラウドには暗号文とルーティング用メタデータしか保存されず、セッションを読むことはできません。新しいクライアント（新しいブラウザやスマートフォン）は、復号する前にデバイスとペアリングする必要があります。',
        p2: 'ブラウザまたはモバイルアプリからペアリングを開始し、デバイス上の jcode Desktop で「設定 → クラウド」を開きます。クライアント名を確認し、10 分以内に承認または拒否してください。CLI は自動化にも利用できます：',
        code1: 'jcode cloud pairings',
        code2: 'jcode cloud approve <pairing_id>',
        p3: '承認には Desktop の「設定 → クラウド」を推奨します。自動化では `pairings` で保留中の要求を確認し、`approve` で承認できます（拒否は `jcode cloud deny <pairing_id>`）。',
      },
      keys: {
        title: '鍵とリカバリー',
        p1: '暗号鍵（CEK）は最初のデバイスで生成され、平文でデバイスの外に出ることはありません。24 語のリカバリーフレーズとして一度バックアップし、安全な場所に保管してください：',
        code1: 'jcode cloud key show-phrase',
        p2: 'すべてのデバイスを失った場合は、新しくサインインしたデバイスでフレーズから鍵を復元します：',
        code2: 'jcode cloud key recover',
        p3: '鍵をローテーションする場合（ペアリング済みクライアントは再ペアリングが必要）：',
        code3: 'jcode cloud rotate-key',
      },
      commands: {
        title: 'コマンドリファレンス',
        p1: '日常使いのコマンド（すべてデバイス上で実行）：',
        rows: {
          login: 'このマシンを jcode Cloud にサインインします（デバイスコードフロー）。',
          loginStatus: '現在のサインイン状態を表示して終了します。',
          logout: 'サインアウトし、デバイストークンを失効させ、ローカル資格情報を削除します。',
          cloudStatus: 'クラウド URL、デバイス ID、鍵世代、到達可能性を表示します。',
          pairings: 'クライアントからの保留中ペアリングリクエストを一覧します。',
          approve: 'ペアリングリクエストを承認します（暗号化された鍵をクライアントへ渡します）。',
          deny: 'ペアリングリクエストを拒否します。',
          showPhrase: '暗号鍵の 24 語リカバリーフレーズを表示します。',
          recover: 'リカバリーフレーズから暗号鍵を再構築します。',
          rotateKey: '新しい鍵を生成します（key_gen+1）。ペアリング済みクライアントは再ペアリングが必要です。',
        },
        e2eeNote: 'E2E 暗号はデフォルトで有効です。一時的に無効にする（平文アップリンク、デバッグ用）には、`~/.jcode/config.json` に "cloud": { "e2ee": false } を設定して `jcode web` を再起動してください。',
      },
    },
    pairing: {
      start: 'このクライアントをペアリング',
      requests: {
        title: 'ペアリング要求',
        body: '承認済みのこのクライアントから、別のブラウザーやスマートフォンを安全に承認できます。',
        approve: '承認',
        deny: '拒否',
        approvalLost: 'このクライアントの承認は失効しました。先に再ペアリングしてください。',
      },
      idle: {
        title: 'エンドツーエンド暗号化が未設定です',
        body: 'このクライアントからペアリングを開始してください。jcode Desktop の「設定 → クラウド」に確認要求が表示され、そこで承認するまで暗号化された内容はロックされたままです。',
      },
      pending: {
        title: 'デバイスでの承認待ち',
        body: 'デバイス上の jcode Desktop で「設定 → クラウド」を開き、このクライアントを確認して 10 分以内に承認または拒否してください。',
      },
      denied: {
        title: 'ペアリングが拒否されました',
        body: 'デバイスがこのペアリング要求を拒否しました。誤りであれば新しく開始してください。',
      },
      expired: {
        title: 'ペアリングの期限切れ',
        body: 'ペアリング要求が 10 分以内に承認されませんでした。新しく開始してください。',
      },
      gate: {
        title: 'ペアリングが必要です',
        body: 'このデバイスはエンドツーエンド暗号化を強制しています。ペアリングが完了するまで、セッション内容と操作は利用できません。',
      },
      error: {
        title: 'ペアリングに失敗しました',
        body: 'ペアリング中に問題が発生しました。もう一度お試しください。',
      },
    },
    securityEyebrow: 'デバイスのサインイン',
    title: 'デバイスを承認',
    lede: 'jcode Desktop がこのクラウドへのサインインを要求しています。Desktop に表示されたコードを入力してください。',
    safetyTitle: '自分で開始したリクエストのみ承認してください',
    enterTitle: 'Desktop のコードを入力',
    codeLabel: 'デバイスコード',
    codeHint: 'jcode Desktop に表示される 8 文字のコード（例: XXXX-XXXX）。',
    codeCell: '{total} 文字中 {n} 文字目',
    codeRequired: 'jcode Desktop に表示されているコードを入力してください。',
    continue: '続行',
    confirmTitle: 'このデバイスはあなたのものですか？',
    confirmBody: 'このコードが jcode Desktop に表示されている現在のサインイン要求と一致する場合のみ承認してください。',
    approve: '承認',
    deny: '拒否',
    approvedTitle: 'デバイスを承認しました',
    approvedBody: 'jcode Desktop に戻ると、サインインが自動的に完了します。',
    deniedTitle: 'デバイスを拒否しました',
    deniedBody: 'サインイン要求は拒否されました。jcode Desktop は待機を停止します。',
    another: '別のデバイスを承認',
    unavailableTitle: 'このサインインリクエストは利用できません',
    tryAnotherCode: '別のコードを入力',
    backToDevices: 'デバイス一覧に戻る',
    errorNotFound: 'そのコードに一致する保留中のサインインはありません。期限切れの可能性があります。jcode Desktop からもう一度開始してください。',
    errorAlreadyDecided: 'そのサインインはすでに承認または拒否されています。',
    errorGeneric: 'デバイスを承認できませんでした。もう一度お試しください。',
  },

  projectDetail: {
    promptRequired: 'エージェントに実行させるタスクを記述してください。',
    sessionStarted: 'セッションを開始しました。',
    startRunFailed: '実行の開始に失敗しました。',
    defaultModelUpdated: 'デフォルトモデルを更新しました。',
    defaultModelFailed: 'デフォルトモデルを設定できませんでした。',
	runnerProfileUpdated: 'ランタイムプロファイルを更新しました。',
	runnerProfileFailed: 'ランタイムプロファイルを設定できませんでした。',
    repoAdded: 'リポジトリ「{name}」を追加しました。',
    addRepoFailed: 'リポジトリの追加に失敗しました。',
    nameRequired: '名前は必須です。',
    repoUrlRequired: 'リポジトリ URL は必須です。',
    draftPrNeedsProviderUrl: 'ドラフト PR にはプロバイダーのリポジトリ URL が必要です。',
    loadingProject: 'プロジェクトを読み込み中…',
    loadFailedTitle: 'プロジェクトを読み込めませんでした',
    projects: 'プロジェクト',
    cluster: 'Cluster',
    projectWorkspace: 'プロジェクトワークスペース',
    addService: 'サービスを追加',
    deleteService: 'サービスを削除',
    deleteServiceAria: '{name} サービスを削除',
    deleteServiceConfirm: 'サービス「{name}」を削除しますか？実行中のタスクを停止した後、このサービスのすべての実行、イベント、成果物、自動化、ワークスペースリソースを完全に削除します。この操作は元に戻せません。',
    serviceDeleted: 'サービス「{name}」を削除しました。',
    deleteServiceFailed: 'サービスを削除できませんでした。',
    breadcrumb: 'パンくずリスト',
    backToWorkspace: 'プロジェクトワークスペースに戻る',
    projectSettings: 'プロジェクト設定',
    kanban: 'Agent Board',
    kanbanRetryTitle: 'Kanban リンクを読み込めませんでした。再試行してください。',
    kanbanUnavailableRetry: 'Kanban 利用不可 · 再試行',
    demoTag: 'DEMO',
    noRepositoriesYet: 'サービスはまだありません',
    repositoriesCount_one: '{count} リポジトリ',
    repositoriesCount_other: '{count} リポジトリ',
    openProvider: '{provider} を開く',
    repoUrlUnresolved: 'サーバーはこのプロバイダーリポジトリのブラウザ URL を解決できませんでした。',
    repositoryUnavailable: 'リポジトリ利用不可',
    addRepoEmptyTitle: 'サービスを追加して開始',
    addRepoEmptyManage: 'サービスはプロジェクトを Git リポジトリに接続し、実行対象になります。',
    addRepoEmptyMember: '実行する前に、プロジェクト所有者がサービスを追加する必要があります。',
    firstServiceEyebrow: 'プロジェクトのセットアップ',
    firstServiceAction: '最初のリポジトリを接続',
    firstServiceSetupTitle: '最初のサービスを追加',
    firstServiceSetupDescription: 'リポジトリを選択してください。接続すると、タスクと自動化の実行対象になります。',
    source: 'ソース',
    directCredential: '直接（あなたの認証情報）',
    gitProvider: 'Git プロバイダー',
    pickRepository: 'リポジトリを選択',
    searchRepositories: 'リポジトリを検索…',
    loadingRepositories: 'リポジトリを読み込み中…',
    listReposFailed: '{source} リポジトリを一覧表示できませんでした。',
    integrationSource: '連携',
    addRepoByUrlInstead: ' 代わりに下からリポジトリを URL で追加してください。',
    noRepositoriesMatch: '一致するリポジトリがありません。',
    private: 'プライベート',
    orAddByUrl: 'または URL で追加',
    repositoryName: 'リポジトリ名',
    repositoryUrl: 'リポジトリ URL',
    addRepository: 'リポジトリを追加',
    memberNeedsIntegration: 'Service を追加する前に、GitHub、GitLab、または Gitea の Project Plugin を接続して有効にしてください。',
    configureProjectPlugins: 'プロジェクトプラグインを設定',
    automationsMembersTitle: '自動化はプロジェクトメンバーが利用できます',
    automationsMembersDesc: 'タスク履歴は表示できますが、スケジュールとプロバイダーイベントの管理はプロジェクトメンバーが行う必要があります。',
    automationsNeedServiceTitle: '自動化にはサービスが必要です',
    automationsNeedServiceDesc: '先にリポジトリを接続してください。スケジュールとプロバイダーイベントはサービス単位にスコープされます。',
  },

  plugins: {
    title: 'プラグイン', projectPlugin: 'プロジェクトプラグイン', intro: 'このプロジェクトではプロバイダーを一度だけ接続します。正常で有効なプラグインはすべてのプロジェクトタスクで利用できます。',
    readOnly: 'プラグイン接続を変更できるのはプロジェクトオーナーまたは Cluster 管理者だけです。', loading: 'プラグインを読み込み中…', loadError: 'プラグインを読み込めませんでした。',
    notConnected: '未接続', connect: '接続', connectError: 'プロバイダー接続を開始できませんでした。', summary: 'サービス {services} 件 · 自動化 {automations} 件',
    back: 'プラグインに戻る', identity: '接続済みの ID', scopes: '許可されたアクセス', noScopes: '現在、プロバイダーアクセスは許可されていません。',
    resources: 'リソース', noResources: 'プロジェクトリソースはまだ紐付けられていません。', automationSummary: '自動化', openAutomations: '自動化を開く', audit: '接続監査',
    noAudit: '監査イベントはまだ記録されていません。', reconnect: '再接続', stableId: '安定 ID: {id}', consentRecorded: '同意 {version} · {time}', unknown: '不明',
    resourcesLoadError: 'プロバイダーリソースを一覧できませんでした。', boundWorkspace: '紐付けたワークスペース', selectWorkspace: 'ワークスペースを選択…', workspaceSetupHint: 'ワークスペースを選択すると、JType プラグインの設定が完了して有効になります。',
    workspace: 'ワークスペース', columns: '{count} 列', private: '非公開', public: '公開', defaultBranchUnknown: 'デフォルトブランチ不明', services: '関連サービス',
    noServices: 'このプラグインに紐付いたサービスはありません。', noAutomations: 'このプラグインに依存する自動化はありません。', auditLoadError: 'プラグイン監査履歴を読み込めませんでした。', auditLoading: '監査履歴を読み込み中…',
    impactLoading: '影響範囲を読み込み中…', impactLoadError: '影響範囲を読み込めませんでした。', impactSummary: 'サービス {services} 件と自動化 {automations} 件が完全に削除されます。',
    forceUninstall: 'プロバイダー Webhook のクリーンアップだけが失敗している場合はローカル削除を強制します。外部フックが残る可能性があります。',
    enable: 'プラグインを有効化', disable: 'プラグインを無効化', uninstall: 'プラグインをアンインストール', uninstallHint: 'アンインストールすると、外部クリーンアップ後に依存するサービスと自動化が完全に削除されます。', uninstallTitle: '{provider} をアンインストールしますか？', uninstallConfirm: 'この操作は元に戻せません。ローカルのプラグイン削除後も外部 Webhook のクリーンアップが継続することがあります。', uninstallType: '確認するには UNINSTALL と入力', invalidProvider: 'このプロバイダープラグインは存在しません。',
    consentTitle: '{provider} に接続', consentIntro: '続行する前に、この接続が jcode Cloud に付与するプロジェクト全体のアクセスを確認してください。', consentScope: 'プロバイダーは、このプラグインに必要なコード、ブランチ、プルリクエスト、Issue、コメント、チェック、タグ、リリース、Webhook へのアクセスを要求します。', consentShared: 'トークンはインストールした人の個人資格情報ではなく、プロジェクト共有の資格情報になります。', consentTasks: 'すべてのプロジェクトタスクは、このプラグインを含む有効なすべてのプラグインを受け取ります。', consentPersistence: 'この接続はインストールした人がプロジェクトを離れた後も、切断またはプロバイダーで取り消されるまで継続します。', consentPublic: '公開リポジトリでは、@jcode コメントにより、すべての有効なプロジェクトプラグイン資格情報を受け取るタスクが開始されます。', consentAcknowledge: 'このプロジェクト全体のアクセスを理解し、承認します。', continueToProvider: 'プロバイダーへ進む',
    incompleteResponse: 'プロバイダーから不完全な接続レスポンスが返されました。',
    providerInstance: 'プロバイダーインスタンス', configuredClusterInstance: 'Cluster に設定されたインスタンス', requestedScopes: '要求するスコープ',
    githubChooseInstallation: 'GitHub App Installation を選択',
    githubChooseInstallationHint: '同意する前に Installation を選択し、実際の権限を確認してください。この選択はこのプロジェクト専用で、自動的に他のプロジェクトへ再利用されません。',
    githubInstallationsLoading: 'GitHub Installations を読み込み中…', githubInstallationsLoadError: 'GitHub Installations を一覧表示できませんでした。',
    githubInstallationSummary: '{target} · {selection} リポジトリ',
    githubTarget: { organization: '組織', user: 'ユーザー' }, githubSelection: { selected: '選択済み', all: 'すべて' },
    githubInstallationsEmpty: '管理可能な GitHub App Installation がありません。GitHub で App をインストールするかリポジトリ範囲を調整して、再試行してください。',
    githubActualPermissions: '{account} の実際の権限',
    githubPermissionsAcknowledge: 'これらの GitHub App の実際の権限を確認し、上記のプロジェクト全体の資格情報リスクを承認します。',
    githubConnectInstallation: 'この Installation に接続',
    jtypeApprove: 'JType で承認', jtypeApproveHint: '確認コード <code>{code}</code> を使用してください。JType が許可を確認するまで、このダイアログは状態を確認し続けます。',
    jtypeOpenConsent: 'JType の同意ページを開く', jtypeStatusLoadError: 'JType の接続状態を確認できませんでした。',
    connectionStatusLabel: '状態: {status}',
    connectionStatus: { pending: '承認待ち', complete: '完了', expired: '期限切れ', denied: '拒否', unsupported: '未対応', checkFailed: '状態を確認できません' },
    coarseScope: {
      gitlab: 'GitLab の粗粒度な api scope は、このプラグインが通常必要とする範囲より広い API 読み書きを許可する可能性があります。これには外部ロールで変更可能なリポジトリ設定も含まれます。jcode には、破壊的な API 呼び出しを技術的にすべて防止するコマンド許可リストはありません。',
      gitea: 'インスタンスのバージョンと外部ロールによっては、Gitea の粗粒度な write:repository scope が通常のタスクフローを超えるリポジトリ設定変更や破壊的操作を許可する可能性があります。jcode にはコマンド許可リストはありません。',
      jtype: 'JType の full scope は、Kanban トリガーだけでなく、選択したクラウドワークスペースでサポートされるすべての読み書き操作を許可します。',
    },
    healthError: {
      jtypeStartFailed: 'JType のデバイス認証を開始できませんでした。',
      webhookCleanupFailed: 'プロバイダー Webhook のクリーンアップに失敗しました。アンインストールを再試行するか、外部 Webhook が残る可能性を承認してローカル削除を強制してください。',
      runtimeCleanupFailed: 'ランタイムのクリーンアップに失敗しました。Cluster が正常になってからアンインストールを再試行してください。',
      oauthRefreshFailed: 'OAuth アクセスの期限が切れ、更新にも失敗しました。このプラグインを再接続してください。',
      providerConfigChanged: 'Cluster のプロバイダー設定が変更されました。このプロジェクトプラグインを再接続してください。',
    },
    apiError: {
      githubAppNotConfigured: 'GitHub App の設定が不完全です。Cluster 管理者に App ID、秘密鍵、Webhook Secret の設定を依頼してください。',
      githubIdentityRequired: 'この App Installation を管理できる GitHub アカウントでサインインしてください。',
      githubInstallationForbidden: '現在の GitHub アカウントでは、選択した App Installation を管理できません。',
      githubAppError: 'GitHub が選択した App Installation を検証できませんでした。再試行してください。',
      consentScopeChanged: 'GitHub App の権限が変更されました。現在の権限を再確認して同意してください。',
      providerNotConfigured: 'このプロバイダープラグインは Cluster で設定または有効化されていません。',
      credentialUnavailable: 'プラグイン資格情報を利用できません。プラグインを再接続してください。',
      reconnectRequired: 'プラグイン設定が変更されたか認証の期限が切れました。プラグインを再接続してください。',
      connectExpired: '接続要求の期限が切れました。接続をやり直してください。',
      workspaceUnavailable: '現在の認証では、選択した JType ワークスペースを利用できません。',
      workspaceRequired: 'このプラグインを有効にする前に JType ワークスペースを選択してください。',
      webhookCleanupFailed: 'プロバイダー Webhook のクリーンアップに失敗しました。アンインストールを再試行するか、ローカル削除を明示的に強制してください。',
      runtimeCleanupFailed: 'ランタイムのクリーンアップに失敗しました。Cluster が正常になってから再試行してください。',
      connectUnsupported: 'このプロバイダーの接続フローはまだサポートされていません。',
      encryptionUnavailable: 'Cluster の暗号化キーが設定されていません。Cluster 管理者に連絡してください。',
      consentRequired: '接続する前に、現在のプロジェクトプラグイン同意事項を確認して承認してください。',
      providerUnavailable: 'プロバイダーが要求を完了できませんでした。可用性と権限を確認して再試行してください。',
      generic: 'プラグイン操作を完了できませんでした。再試行してください。',
    },
    auditEvent: {
      consent_accepted: '同意済み', connected: '接続済み', reconnected: '再接続済み', reconnect_started: '再接続を開始',
      configuration_changed: '設定を変更', uninstall_cleanup_failed: 'アンインストールのクリーンアップに失敗', uninstalled: 'アンインストール済み', force_uninstalled: '強制アンインストール済み',
    },
    status: { not_connected: '未接続', connecting: '接続中', enabled: '有効', disabled: '無効', action_required: '操作が必要', uninstalling: 'アンインストール中', error: 'エラー' },
    trigger: { scm: 'SCM イベント', kanban: 'Kanban 列', cron: 'Cron スケジュール' },
    systemActor: 'システム',
  },

  automationEditor: {
    loading: '自動化を読み込み中…', loadError: '自動化を読み込めませんでした。', eyebrow: 'リポジトリ自動化', createTitle: '自動化を作成', editTitle: '自動化を編集',
    subtitle: 'このリポジトリに型付きトリガーを 1 つ関連付けます。', viewerWarning: '閲覧者は設定を確認できますが、自動化を保存できません。',
    task: 'タスク', name: '名前', service: 'リポジトリ', selectService: 'リポジトリを選択…', serviceUnavailable: 'リポジトリを利用できません',
    model: 'モデル', selectModel: 'モデルを選択…', effort: '推論強度', effortAuto: '自動', effortLow: '低', effortMedium: '中', effortHigh: '高',
    effortHint: 'このモデルは推論強度の設定をサポートしています。', promptTemplate: 'プロンプトテンプレート',
    enabled: '有効', ignoreJcode: 'jcode が作成したイベントを無視', trigger: 'トリガー', scm: 'SCM', cron: 'Cron',
    selectGitService: 'GitHub、GitLab、または Gitea のリポジトリを接続してください。', capabilitiesLoadError: 'プロバイダー機能を読み込めませんでした。',
    branchFilter: 'ブランチフィルター', branchPlaceholder: 'main または feature/*', branchHint: 'ブランチ情報を持つ Push、PR、Check イベントで使用できます。',
    pathPattern: 'パスパターン', pathHint: '選択したすべてのイベントが push.updated の場合のみ使用できます。',
    conclusion: 'CI 結果', conclusionHint: '選択したすべてのイベントが check.completed の場合のみ使用できます。',
    events: 'イベント', moreEvents: 'その他のイベント', thisProvider: 'このプロバイダー', eventUnavailable: '{provider}{version} ではサポートされていません。',
    cronExpression: 'Cron 式', cronHint: '5 フィールドの Cron 式を使用します。最小間隔はサーバーで強制されます。',
    outputMode: '出力', outputRun: 'Run を直接作成', outputCard: 'jtype Card を作成して Agent Board で実行',
    outputHint: 'Card 出力は jtype の作業項目を残し、通常の Kanban 受付・書き戻しフローを使用します。',
    openBoardSettings: 'Agent Board の設定を開く',
    outputCardUnavailable: '正常な Agent Board を接続してから Card 出力を選択してください。',
    create: '自動化を作成', save: '自動化を保存',
    review: {
      eyebrow: 'GitHub コードレビュー', title: 'Pull Request をレビュー', subtitle: '新しい手順を覚えなくても、GitHub ネイティブのレビューを有効にできます。',
      defaultName: 'Pull Request レビュー', setup: 'レビュー設定',
      automaticTitle: 'デフォルトで自動', automaticBody: 'Pull Request の準備が整った時と、新しいコミットごとに App がレビューします。',
      repeatTitle: 'GitHub から再実行', repeatBody: 'このコマンドを Pull Request のコメントに貼り付けます。GitHub の @ 補完にカスタム App が出ない場合でも、完全なコマンドで起動できます。',
      focus: 'レビューの重点（任意）', focusPlaceholder: '例：認可境界を特に確認する。', focusHint: '正確性、セキュリティ、信頼性、データ損失、回帰は常に確認します。',
      when: 'レビューするタイミング', readyTitle: '準備済みの Pull Request', readyBody: '新規 Pull Request と Draft 解除時にレビューします。',
      updatesTitle: '新しいコミット', updatesBody: 'Pull Request の先頭が変わると再レビューします。',
      draftsTitle: 'Draft を含める', draftsBody: '通常はオフにして、作者の最初の確認を待ちます。',
      create: 'レビューを有効化', save: 'レビュー設定を保存',
    },
    validation: { noPermission: '自動化を編集する権限がありません。', required: '名前、リポジトリ、モデル、タスクプロンプトは必須です。', eventRequired: 'このリポジトリのプロバイダーがサポートするイベントを 1 つ以上選択してください。', cronRequired: 'Cron 式は必須です。', cardOutputUnavailable: 'Card 出力には正常な Agent Board が必要です。' },
    apiError: {
      overlap: '選択した SCM イベントのいずれかを、このリポジトリの別の自動化がすでに使用しています。',
      webhook: '自動化は保存されましたが、プロバイダー Webhook を同期できませんでした。プラグイン接続を確認して再試行してください。',
      pluginUnavailable: '選択したリポジトリ接続が利用できないか、このトリガーに対応していません。',
      modelUnavailable: '選択したモデルはこのアカウントで利用できません。別のモデルを選択してください。',
      modelRequired: 'このアカウントに許可されたモデルを選択してください。',
      effortUnsupported: '選択したモデルは推論強度に対応していません。自動または推論モデルを使用してください。',
      generic: '自動化を保存できませんでした。再試行してください。',
    },
  },

  automationExecutions: {
    loading: '自動化を読み込み中…', loadError: '自動化を読み込めませんでした。', back: '自動化一覧に戻る',
    cardOutput: 'Card 出力', runOutput: '直接 Run 出力', runNow: '今すぐ実行',
    runNowError: '実行を受理できませんでした。再試行時も同じ冪等キーを使用します。',
    history: '実行履歴', loadingHistory: '実行履歴を読み込み中…', historyError: '実行履歴を読み込めませんでした。',
    empty: '実行履歴はまだありません。', loadMore: '以前の実行を読み込む', select: '実行を選択して詳細を確認します。',
    selected: '選択した実行', execution: '実行', trigger: 'トリガー', kind: '種類',
    requested: '依頼者', accountable: '責任者', notApplicable: '該当なし', unattributed: '帰属なし',
    output: '出力', expected: '予定', cardThenRun: 'jtype Card → Kanban Run', directRun: '直接 Run',
    actual: '実際', writeback: '書き戻し', usage: '使用量', usageUnavailable: '利用不可',
    filter: { all: 'すべて', blocked: 'ブロック', running: '実行中', terminal: '完了済み' },
    state: {
      accepted: '受付済み', ignored: '無視', duplicate: '重複',
      superseded: '置換済み', blocked: 'ブロック', queued: '待機中',
      running: '実行中', terminal: '完了済み',
    },
    outcome: { succeeded: '成功', failed: '失敗', canceled: 'キャンセル' },
    repair: {
      project_owner: 'プロジェクト所有者がこの依存関係を修復できます。',
      repository_owner: 'リポジトリ所有者がこの依存関係を修復できます。',
      cluster_admin: 'クラスター管理者がこの依存関係を修復する必要があります。',
      requester: 'リクエストしたユーザーがこの依存関係を修復する必要があります。',
    },
    title: {
      blocked: '出力前にブロック', ignored: 'ルールにより無視',
      card: 'Card 出力', run: 'Run 出力',
    },
  },

  projectAutomations: {
    eyebrow: 'リポジトリ自動化', title: '自動化', subtitle: 'このリポジトリに SCM とスケジュール作業を作成します。Agent Board はリポジトリヘッダーから設定します。',
    loading: '自動化を読み込み中…', loadError: '自動化を読み込めませんでした。', new: '新しい自動化', noServices: '自動化を作成する前にリポジトリを接続してください。',
    filters: '自動化フィルター', all: 'すべて', empty: 'この表示に一致する自動化はありません。', edit: '編集', delete: '削除',
    back: '自動化に戻る', newTitle: '新しい自動化', editTitle: '自動化を編集', name: '名前', triggerLabel: 'トリガー種別',
    cron: 'Cron 式', action: 'SCM イベント', column: 'トリガー列', prompt: 'タスク指示', incomplete: '保存する前に必須項目をすべて入力してください。',
    create: '自動化を作成', save: '変更を保存', trigger: { scm: 'SCM イベント', kanban: 'Kanban 列', cron: 'Cron スケジュール' },
    enabled: '有効', disabled: '無効', toggleLabel: '{name}: {status}',
    review: { turnOn: 'Pull Request をレビュー', manage: 'レビュー設定', rowSummary: 'GitHub App が変更行に確度の高い問題を投稿します。', native: 'GitHub ネイティブレビュー' },
    error: {
      modelUnavailable: 'このイベントを受信した時点で使用可能なモデルを選択できませんでした。アカウントにモデルを許可し、複数ある場合はリポジトリのデフォルトモデルを設定してください。次回の正常なトリガーでこの履歴エラーは消去されます。',
      modelNotSelected: '複数のモデルを使用できますが、このリポジトリにデフォルトモデルがありません。リポジトリ設定で選択してください。',
      modelNotConfigured: 'このアカウントに許可されたモデルがありません。Cluster 管理者にモデルの許可を依頼してください。',
      modelTemporary: '一時的な内部エラーによりモデル設定を読み取れませんでした。トリガーを再実行してください。',
      triggerUnavailable: 'この自動化のトリガー設定を利用できません。自動化を再保存してください。',
      serviceUnavailable: 'この自動化に関連付けられたリポジトリを利用できません。',
      repositoryUnavailable: 'このリポジトリ接続を利用できません。プロバイダーを再接続してください。',
      runCreateFailed: 'イベントは一致しましたが、自動化タスクを作成できませんでした。',
      invalidCron: 'Cron 式が無効です: {expression}',
      dispatchFailed: 'スケジュール自動化からタスクを作成できませんでした。',
      webhookReconcileFailed: 'SCM Webhook を同期できませんでした。プラグイン資格情報とプロバイダーの Webhook 権限を確認し、自動化を再保存してください。',
    },
  },

  projectSettings: {
    navGeneral: '一般',
    navMembers: 'メンバー',
    navPlugins: 'プラグイン',
    navModels: 'モデルアクセス',
    navApiKeys: 'API キー',
    envInvalidName: '「{key}」は有効な環境変数名ではありません。',
    envReserved: '「{key}」はオーケストレーターによって予約されており、設定できません。',
    projectUpdated: 'プロジェクト「{name}」を更新しました。',
    updateFailed: 'プロジェクトの更新に失敗しました。',
    projectDeleted: 'プロジェクト「{name}」を削除しました。',
    deleteFailed: 'プロジェクトの削除に失敗しました。',
    eyebrow: 'プロジェクト管理',
    title: '設定',
    subtitle: 'プロジェクトコンテナを管理します。リポジトリの動作は各サービスにスコープされたままです。',
    navAria: 'プロジェクト設定セクション',
    generalDesc: 'プロジェクトの ID と実行ガードレール。',
    projectName: 'プロジェクト名',
    projectNameHintPage: 'リポジトリのブランチと git モードはサービスごとに設定します。',
    executionGuardrails: '実行ガードレール',
    guardrailBlankHint: '上限を空欄のままにすると Cluster のデフォルトを継承します。',
    maxConcurrent: '最大同時実行数',
    clusterDefaultPlaceholder: 'Cluster デフォルト',
    runTimeout: '実行タイムアウト（秒）',
    injectedEnv: '注入される環境変数',
    injectedEnvHintPage: 'すべての実行にマージされます。システム変数は予約されています。',
    removeVariable: '変数を削除',
    addVariable: '変数を追加',
    membersTitle: 'メンバーと権限',
    membersDesc: 'このプロジェクトを表示、実行、管理できるユーザーを選択します。',
    pluginsTitle: 'プラグイン',
    pluginsDesc: 'プロジェクトで共有するソース管理と Kanban の接続。',
    modelsDesc: 'このプロジェクトのセッションで現在利用可能なモデル。',
    apiKeysTitle: 'プロジェクト API キー',
    apiKeysDesc: 'API トリガー自動化のための取り消し可能な認証情報。',
    dangerTitle: '危険な操作',
    dangerDesc: '永続的で破壊的なプロジェクト操作。',
    deleteProject: 'プロジェクトを削除',
    deleteHintPage: 'このプロジェクトとそのすべての実行、イベント、アーティファクトを完全に削除します。',
    deleteForGood: '完全に削除しますか？',
    savebarHint: 'プロジェクト設定はサービス設定とは別に保存されます。',
    saveChanges: '変更を保存',
    loadingModelAccess: 'モデルアクセスを読み込み中…',
    modelAccessLoadError: 'モデルアクセスを読み込めませんでした。プロジェクトワークスペースから再試行してください。',
    noModelConfigured: 'このプロジェクトにモデルが設定されていません。Cluster 管理者に付与を依頼してください。',
    granted: '付与済み',
    envFallbackActive: 'Cluster 環境モデルフォールバックが有効です。',
    models: {
      ownedTitle: 'プロジェクトのモデルプロバイダー',
      ownedDescription: 'このプロジェクト専用のプロバイダーを接続し、実行できるモデルを選択します。',
      addProvider: 'プロバイダーを追加',
      providersSummary: 'プロバイダー {providers} 件 · モデル {models} 件',
      noProviders: 'プロジェクトのモデルプロバイダーはまだありません。',
      noProvidersHint: 'プロバイダーを追加して、このプロジェクト専用のモデルを設定します。',
      enableAria: '{name} を有効化',
      disableAria: '{name} を無効化',
      editModelAria: '{name} を編集',
      deleteModelAria: '{name} を削除',
      removeModelConfirm: '{name} を削除しますか？',
      modelRemoved: 'モデルを削除しました。',
      removeModelError: 'モデルを削除できませんでした。',
      updateModelError: 'モデルを更新できませんでした。',
      clearHeadersAction: '設定済みのヘッダーを削除',
      clearHeadersPending: '保存時に設定済みヘッダーを削除します · クリックで取り消し',
      editDialogTitle: 'モデルを編集 · {name}',
      saveModel: 'モデルを保存',
      modelSaved: 'モデルを保存しました。',
      saveModelError: 'モデルを保存できませんでした。',
      availableTitle: '利用可能なモデル',
      defaultTitle: 'プロジェクトのデフォルトモデル',
      defaultDescription: 'Automation または Service がより具体的なモデルを選択していない場合に使用します。',
      noDefault: 'プロジェクトのデフォルトなし',
      availableOwnerHint: 'このプロジェクトが実行できるすべてのモデル — 独自のモデルと Cluster 管理者が付与したモデルを含みます。',
      availableMemberHint: 'Cluster 管理者またはプロジェクトオーナーがこのプロジェクトに提供したモデルです。',
    },
    name: '名前',
    guardrails: 'ガードレール',
    apiKeyCreated: 'API キー「{name}」を作成しました。',
    apiKeyCreateFailed: 'API キーを作成できませんでした。',
    apiKeyRevoked: 'API キーを取り消しました。',
    apiKeyRevokeFailed: 'API キーを取り消せませんでした。',
    apiKeyIntro1: 'プロジェクトスコープのキーは ',
    apiKeyIntro2: ' として認証され、このプロジェクトの実行のトリガーと読み取りのみを行えます — 他のプロジェクト、このプロジェクトの設定やメンバー、Cluster 管理者サーフェスには一切アクセスできません。Cluster 全体のコンソールトークンの代わりに、外部/CI 自動化に使用してください。',
    apiKeysEmpty: 'API キーはまだありません — 下から作成してください。',
    apiKeyNameHint: '後でキーを区別するのに役立ちます — 使用する CI ジョブなど、識別しやすいものを選んでください。',
    createKey: 'キーを作成',
    apiKeyRevealTitle: '「{name}」を作成しました',
    apiKeyRevealHint: '一度だけ表示されます — 今すぐコピーしてください。再表示はできません。紛失した場合は、このキーを取り消して新しいものを作成してください。',
    statusRevoked: '取り消し済み',
    statusActive: 'アクティブ',
    createdAt: '作成日 {time}',
    lastUsed: ' · 最終使用 {time}',
    neverUsed: ' · 未使用',
    revoke: '取り消し',
  },

  projectWorkspace: {
    railServicesAria: 'プロジェクトサービス',
    projectEyebrow: 'プロジェクト',
    serviceCount_one: '{count} サービス',
    serviceCount_other: '{count} サービス',
    servicesHeading: 'サービス',
    noServiceConnected: '接続されているサービスはまだありません。',
    workspaceAria: '{projectName} ワークスペース',
    tabsAria: 'プロジェクトワークスペースのセクション',
    tabTasks: 'タスク',
    tabAutomations: '自動化',
    tabServiceSettings: 'サービス設定',
  },

  taskComposer: {
    eyebrow: '新しいタスク',
    heading: '{name} でセッションを開始',
    isolation: '隔離されたワークスペースで実行',
    messageAria: 'メッセージ',
    placeholder: '完了させる作業を記述…',
    permissionModeAria: '権限モード',
    permissionModeTitle: 'フルアクセスはエージェントを自動承認します。操作前に確認は、タイムラインでの承認のためにエージェントを一時停止します。',
    fullAccess: 'フルアクセス',
    askBeforeActions: '操作前に確認',
    session: 'セッション',
    modelAria: 'モデル',
    serviceDefault: 'Repository デフォルト',
    serviceDefaultWithModel: 'Repository デフォルト · {model}',
    branchAria: 'ベースブランチ',
    branchDefault: 'デフォルト',
	branchLoading: 'ブランチを読み込み中…',
    branchUnavailable: 'ブランチを更新できませんでした。Plugin 接続を修復してからもう一度試してください。',
    effortAria: '推論の強度',
    effortAuto: '推論 · 自動',
    effortLow: '推論 · 低',
    effortMedium: '推論 · 中',
    effortHigh: '推論 · 高',
    add: '追加',
    addMenu: 'タスクに追加',
    goalMode: 'Goal モード',
    goalPlaceholder: '継続して取り組む目標を記述…',
    goalModeHint: '次のタスクを継続的な Goal として開始します。',
    disableGoalMode: 'Goal モードをオフにする',
    attachments: '添付ファイル',
    addAttachments: '添付ファイルを追加',
    removeAttachment: '{name} を削除',
    attachmentTooMany: '添付ファイルは最大 {max} 件です。',
    attachmentTooLarge: '{name} は 25 MiB を超えています。',
    attachmentTotalTooLarge: '1 回の実行で添付できる合計サイズは最大 {max} MiB です。',
    attachmentUploadFailed: '添付ファイルをアップロードできませんでした。',
    send: '送信',
  },


  settingsPanel: {
    emptyTitle: '設定には Repository が必要です',
    emptyDescription: 'モデルポリシーを設定する前にリポジトリを接続してください。',
    eyebrow: 'Repository 設定',
    description: 'この Repository の実行ポリシー。プロバイダー接続は別途管理されます。',
    source: 'ソース',
    provider: 'プロバイダー',
    defaultBranch: 'デフォルトブランチ',
    gitMode: 'Git モード',
    gitModeDraftPr: 'ドラフトプルリクエスト',
    gitModeReadOnly: '読み取り専用',
    modelPolicyEyebrow: 'モデルポリシー',
    modelPolicyTitle: 'Repository デフォルトモデル',
    modelPolicyDescription: 'タスクコンポーザーが実行ごとの選択を Repository デフォルトのままにした場合にのみ使用されます。',
    modelsLoading: 'アカウントのモデルアクセスを読み込み中…',
    modelsUnverified: 'このアカウントのモデルアクセスを検証できませんでした。モデルカタログが利用可能になるまでデフォルトを変更しないでください。',
    retryModelCheck: 'モデルチェックを再試行',
    defaultModelAria: 'このリポジトリのデフォルトモデル',
    noDefault: 'デフォルトなし',
    noModelGranted: 'このアカウントにモデルが許可されていません。Repository デフォルトを選択する前に、Cluster 管理者が許可する必要があります。',
	runtimePolicyEyebrow: 'ランタイムポリシー',
	runtimePolicyTitle: 'Runner 環境',
	runtimePolicyDescription: 'この Repository の各 Run に、管理者が管理する不変のツールチェーン環境を選択します。',
	runnerProfileAria: 'このリポジトリの Runner 環境',
	runtimeProfilesUnavailable: 'ランタイムプロファイルを読み込めませんでした。現在の設定は変更されません。',
  },

  webhook: {
    errSync: 'プロバイダー Webhook を同期できませんでした。再試行するか、Cluster 管理者にお問い合わせください。',
    eyebrowReview: 'PR レビュー Webhook',
    unavailableTitle: 'プロバイダーイベントにはプロバイダーバックのリポジトリが必要です',
    pathOrUrlNote: 'はパスまたは raw URL のため、プルリクエストまたはマージリクエストのコメントイベントを受信できません。',
    readonlyTitle: '自動化は閲覧者には読み取り専用です',
    readonlyBody: 'プロジェクトメンバーは {provider} を接続し、このリポジトリのレビュー Webhook を同期できます。',
    oauthNotConfiguredTitle: 'この Cluster では {provider} OAuth が設定されていません',
    oauthNotConfiguredBody: 'Cluster 管理者に {provider} OAuth と Webhook レシーバーの設定を依頼してください。フォールバック認証情報は使用されません。',
    serviceTitle: 'サインインしたプロジェクトメンバーが {provider} を認可する必要があります',
    serviceBody: 'コンソールトークンセッションには個人 OAuth ID がありません。この Webhook を同期するには、プロジェクトメンバーアカウントでサインインしてください。',
    eyebrowProvider: 'プロバイダー Webhook',
    connectTitle: 'PR レビューコマンドのために {provider} を接続',
    connectBodyPre: '次のリポジトリを管理するアカウントを接続してください: ',
    connectBodyPost: '。jcode はこのリポジトリの OAuth 権限をリクエストします。ここで個人アクセストークンを貼り付けるよう求めることはありません。',
    connectCta: '{provider} を OAuth で接続',
    readyTitle: '{provider} PR レビューコマンド',
    readyBodyPre: 'Sync は次のリポジトリのプロバイダーコメント Webhook を登録します: ',
    readyBodyMid: ' — あなたの {provider} OAuth アカウントを使用します。コラボレーターは次のコマンドでレビューを開始できます: ',
    readyBodyPost: '。リポジトリが変更されたときに再実行しても安全です。',
    oauthConnected: 'OAuth が接続されています。',
    synchronizing: 'Webhook を同期中…',
    setupReady: 'Webhook のセットアップ準備完了。',
    syncedTo: 'Webhook の同期先: ',
    syncButton: '{provider} Webhook を同期',
    reconnectOauth: 'OAuth を再接続',
  },

  runActivity: {
    eyebrow: 'アクティビティ',
    title: '最近のタスク',
    filtersAria: '最近のタスクを絞り込み',
    filterAll: 'すべて',
    filterSessions: 'セッション',
    filterReviews: 'レビュー',
    loadingTasks: 'タスクを読み込み中…',
    errorTitle: 'タスクを読み込めませんでした',
    emptyTitleAll: 'タスクはまだありません',
    emptyTitleFiltered: 'この Repository に {filter} はありません',
    emptyDescDispatch: '上のコンポーザーを使って最初のタスクをディスパッチしてください。',
    emptyDescNone: 'このプロジェクトではまだタスクがディスパッチされていません。',
    emptyDescFiltered: '別のフィルターを試すか、別の Repository を選択してください。',
    runAria: '{kind}: {summary} — {status}',
    retryTitle: '以前の実行の再試行',
    retryBadge: '再試行',
  },

  projectSettingsAction: {
    label: 'プロジェクト設定',
  },

  codeReviewsPage: { eyebrow: '独立ワークフロー', title: 'Code reviews', description: 'Repository 横断の Review Run を実装タスクと分けて表示します。', createEyebrow: '新しいレビュー', createTitle: 'Code review を開始', createDescription: 'Repository と、完了した Cloud タスクが作成した Pull request を選択します。', loadingSources: 'レビュー可能な Pull request を読み込み中…', sourcesError: 'レビュー可能な Pull request を読み込めませんでした。', noRepositories: 'このアカウントで利用できる Repository がありません。', connectRepository: 'Git アカウントアクセスを確認', repositoryLabel: 'Repository', pullRequestLabel: 'Pull request', noReviewablePr: 'レビュー可能な Cloud Pull request がありません。', noReviewablePrDescription: 'Pull request を作成する Repository タスクを実行してから戻ってください。', openWorkHome: 'Work Home を開く', openPullRequest: 'Pull request を開く', createAction: 'Code review を作成', createSuccess: 'Code review を開始しました。', createError: 'Code review を開始できませんでした。', emptyTitle: 'Code review はまだありません', emptyDescription: '各 Repository の Review Run がここに表示されます。' },
  accountHeader: {
    location: 'ワークスペースの位置',
    account: 'アカウント', menu: 'アカウントメニュー', codeReviews: 'コードレビュー', settings: 'アカウント設定', clusterSettings: 'クラスター設定', admin: '管理者', signOut: 'サインアウト',
  },
  accountSettings: {
    back: 'ワークホームに戻る', eyebrow: 'アカウント', title: 'アカウント設定',
    description: 'プロフィール、モデルアクセス、連携済み Git アカウント、使用量、環境設定は、すべての Repository と jcode Desktop に適用されます。',
    tabsAria: 'アカウント設定セクション', profileTab: 'プロフィール', gitAccountsTab: 'Git アカウント', modelsTab: 'モデル', usageTab: '使用量', preferencesTab: '環境設定',
    profileTitle: 'アカウントプロフィール', profileDescription: 'Repository タスクを実行し、会話を所有するために使用する ID です。',
    displayName: '表示名', accountId: 'アカウント ID', role: 'ロール', clusterAdministrator: 'クラスター管理者', member: 'メンバー', executionIdentity: '実行 ID',
    repositoryOwnerDefault: 'デフォルトは Repository owner', currentAccount: '現在のアカウント', sessionAccount: 'セッションアカウント',
    gitAccountsTitle: 'Git アカウント', gitAccountsDescription: '連携済みアカウントから見える Repository は、Work Home のコンテキスト選択に直接表示されます。',
    repositoryAccessUnavailable: 'このアカウントでは Repository にアクセスできません。', connected: 'このアカウントに接続済み', reauthorize: '{provider} を再認証', linkProvider: '{provider} を連携',
    authorizeRepositories: 'このアカウントの Repository を認証', checkingRepositoryAccess: 'Repository アクセスを確認中…', repositoryAccessUnavailableTitle: 'Repository アクセスを利用できません',
    modelsTitle: 'モデルとプロバイダー', modelsDescription: 'モデルはあなたに直接認証され、すべての Repository に適用されます。', loadingModels: 'アカウントモデルを読み込み中…', modelAccessUnavailable: 'モデルアクセスを利用できません',
    noModels: 'このアカウントに認証されたモデルはありません。クラスター管理者に連絡してください。', modelAuthorized: 'アカウントで認証済み', manageAuthorizations: 'クラスター設定でアカウント認証を管理',
    preferencesTitle: '環境設定', preferencesDescription: '対応している範囲で、Cloud と Desktop は同じ言語と表示設定を使用します。',
    language: '言語', languageDescription: 'インターフェースの言語を変更します。', appearance: '外観', appearanceDescription: 'ライトまたはダークテーマを使用します。',
  },
  repositories: {
    openRepository: 'リポジトリ {name} を開く',
    toggleConversations: '{name} の会話を展開または折りたたむ',
    conversationSection: '会話',
    navigationUnavailable: 'このリポジトリは利用できません。Git アカウントの権限を確認するか、別のリポジトリを選択してください。',
    remoteUnavailable: 'このリモートデバイスは利用できません。再接続するか、別のデバイスを選択してください。',

    eyebrow: 'あなたのコード', title: 'Repositories',
    description: '1 つの Repository が、Board・タスク・設定・Code reviews を持つ 1 つの Agent ワークスペースです。',
    composerEyebrow: 'アカウントワークスペース', composerTitle: '次に何をコーディングしますか？',
    composerDescription: '連携アカウントからアクセスできるリポジトリを選び、すぐにタスクを開始できます。',
    remoteComposerDescription: 'オンラインの jcode デバイスで同じ会話 UI を使って作業を続けます。',
    contextAria: 'Repository または Remote コンテキスト {context}', repositoryFallback: 'Repository', remoteBack: 'Repositories に戻る', remoteConnection: 'リモート接続',
    remoteChooseDevice: 'オンラインの jcode デバイスを選択', onlineDevices: 'オンラインデバイス', jcodeDevice: 'jcode デバイス', online: 'オンライン',
    connectNewDevice: '新しいデバイスを接続', connectNewDeviceDescription: 'jcode login を実行して暗号化ペアリングを完了',
    pickerSearchAria: 'Repositories を検索', pickerSearchPlaceholder: 'Repositories を検索…', gitRepositories: 'Git リポジトリ',
    pickerSearchError: 'Repository の検索に失敗しました。検索語を変更するか、もう一度お試しください。', pickerNoMatch: '「{query}」に一致する Repository はありません。',
    remoteConnectionAria: 'リモート接続、オンライン {count} 台', remoteOnlineCount: '{count} 台の jcode デバイスがオンライン', searchingRepositories: 'Repositories を検索中',
    conversationRailAria: '会話', conversationRailWorkHome: 'ワークホーム', conversationRailNew: '新しい会話',
    conversationRailSearchAria: '会話を検索', conversationRailSearchPlaceholder: '会話を検索…', conversationRailByRepository: '最近のリポジトリ',
    conversationRailCollapse: '会話欄を折りたたむ', conversationRailExpand: '会話欄を展開', conversationRailEmptyTitle: '会話はまだありません',
    conversationRailEmptyDescription: 'タスクを開始すると最初の会話が作成されます。', conversationRailNoMatch: '検索に一致する会話はありません。', conversationRailRepositoryUnavailable: 'Repository を利用できません',
    workspaceTasks: 'タスク', workspaceBoard: 'ボード', workspaceReviews: 'コードレビュー', workspaceAutomations: '自動化', workspaceUsage: '使用量', workspaceSettings: '設定',
    cloudRunner: 'クラウド Runner', noTasksTitle: 'この Repository にタスクはありません', noTasksDescription: '上でタスクを入力して最初の会話を開始します。',
    boardDescription: '既存の Board を接続し、Card からこの Repository の Agent を開始します。', reviewsDescription: 'この Repository の独立したコードレビュー Run です。',
    reviewsEmptyDescription: '実装タスクとは分けてレビューを作成します。', boardNotConnected: 'Board が接続されていません',
    boardNotConnectedDescription: '準備ができたら既存の Board を接続できます。Repository ワークスペースはすでに利用できます。', boardWorkflowAria: 'デフォルトの Agent Board ワークフロー',
    boardBacklog: 'バックログ', boardBacklogDescription: '作業待ちの Card', boardAgentQueue: 'Agent キュー', boardAgentQueueDescription: 'jcode を開始する Card',
    boardDoneOptional: '完了（任意）', boardDoneDescription: '成功した結果',
    attachmentsAfterConversation: 'この Repository にアクティブな会話が作成されると、添付ファイルを追加できます。', modeCeilingHint: 'Cloud タスクでは承認、プラン、自動モードを使用できます。',
    baseBranchAria: 'ベースブランチ {branch}', unavailable: '利用不可', loadingBranches: 'ブランチを読み込み中…', branchUnavailable: 'ブランチを利用できません',
    startingRepositoryTask: 'Repository タスクを開始中…', branchesUnavailable: 'Repository のブランチを利用できません。', noToolModel: 'アカウントで認証されたモデルに Agent ツール対応モデルがありません。',
    remoteSetup: 'Remote セットアップ', deviceOffline: 'このデバイスはオフラインです。デバイスで jcode を開いてから再試行してください。', startingConversation: '新しい会話を開始中',
    deviceSlow: 'デバイスの応答に時間がかかっています…', creatingOnDevice: 'デバイス上で作成中…',
    taskAria: 'タスクを説明', taskPlaceholder: 'タスクを説明…', repositoryAria: 'Repository',
    accountLoading: 'リポジトリを読み込み中…', chooseAccountRepository: 'リポジトリを選択',
    modelsLoading: 'モデルを読み込み中…', modelRequired: 'モデルを選択', startTask: 'タスクを開始',
    startFailed: 'タスクを開始できませんでした。', accountLoadError: 'アカウントのリポジトリを読み込めません。プロバイダーを再連携してください。',
    linkAccount: 'Git プロバイダーを連携するとリポジトリを選択できます。', reviewGitAccountAccess: 'Git アカウントの認証を確認',
    authorizeModel: '管理者にアカウント用モデルの承認を依頼してください。', reviewModelAccess: 'モデルの認証を確認',
    detailsTitle: 'Repository の詳細', detailsDescription: '使用済み Repository の設定、Agent Board、タスク履歴を開きます。',
    noDetails: '最初のタスクを開始すると詳細が表示されます。事前の接続手順は不要です。',
    connect: 'Repository を接続', loading: 'Repositories を読み込み中…', loadError: 'Repositories を読み込めませんでした',
    preparing: 'Repository ワークスペースを準備中…', prepareError: 'Repository ワークスペースを準備できません',
    connectionsTitle: 'プロバイダーアカウント', connectionsDescription: 'アカウントプロバイダーと JType アクセスを管理します。Repository の個別接続は不要です。',
    chooseRepository: 'Repository を選択',
    emptyEyebrow: 'コードから開始', emptyTitle: '最初の Repository を接続',
    emptyBody: 'Repository を選んで Agent ワークスペースを作成します。個人ワークスペースは表示しません。',
    listTitle: '接続済み Repositories', visible: '件表示', search: 'Repositories を検索',
    searchPlaceholder: 'owner または repository を検索…', noMatch: '一致する Repository はありません。',
    details: 'Repository 詳細', open: '開く', codeReviews: 'コードレビュー',
    loadingOne: 'Repository を読み込み中…', loadOneError: 'Repository を読み込めませんでした', railAria: 'Repositories', noneConnected: 'Repository はまだ接続されていません。',
    workspaceAria: '{repositoryName} Repository ワークスペース', tabsAria: 'Repository ワークスペースのセクション', tabSettings: 'Repository 設定', connection: 'プロバイダー接続',
    connectionsIntro: '各プロバイダーを Repositories 用に一度だけ接続します。正常な接続は Repository タスクで利用できます。', connectionsReadOnly: 'プロバイダー接続を変更できるのは Repository owner または Cluster 管理者だけです。',
    connectionSummary: '{repositories} Repositories · {automations} Automations', providerRequired: 'Repository を選ぶ前に GitHub、GitLab、または Gitea プロバイダーを接続して有効にしてください。', configureConnections: 'プロバイダー接続を設定',
    disconnect: 'Repository を切断', disconnectAria: '{name} Repository を切断', disconnectConfirm: '「{name}」を切断しますか？アクティブなタスクを停止した後、この Repository の Run、イベント、成果物、自動化、ワークスペースリソースを完全に削除します。この操作は元に戻せません。', disconnected: 'Repository「{name}」を切断しました。', disconnectFailed: 'Repository を切断できませんでした。',
    consentIntro: '{provider} に進む前に、この接続が jcode Cloud に付与するアカウント全体のアクセスを確認してください。', consentShared: 'トークンは Repositories の共有資格情報となり、インストールした個人には属しません。', consentTasks: 'Repository タスクは、この接続を含む有効なプロバイダー接続を利用できます。', consentPersistence: 'この接続は切断またはプロバイダーによる失効まで維持されます。', consentPublic: '公開リポジトリでは、@jcode コメントにより有効なプロバイダー資格情報を使うタスクを開始できます。', consentAcknowledge: 'このアカウント全体の Repository アクセスを理解し、承認します。',
  },
  projects: {
    noServicesConnected: '接続されているサービスはありません',
    serviceCount_one: '{count} サービス',
    serviceCount_other: '{count} サービス',
    eyebrow: 'あなたのワークスペース',
    title: 'プロジェクト',
    description: 'プロジェクトは、1 つのプロダクトを提供する人、サービス、モデルアクセス、自動化ポリシーをまとめます。',
    newProject: '新規プロジェクト',
    loadingProjects: 'プロジェクトを読み込み中…',
    loadError: 'プロジェクトを読み込めませんでした',
    empty: {
      eyebrow: '境界から始める',
      title: 'プロジェクトはまだありません。',
      body: '最初のプロジェクトを空のコンテナとして作成します。次の画面では、利用できないプロバイダーが接続されているように見せかけることなく、リポジトリをサービスとして認可できます。',
      cta: '最初のプロジェクトを作成',
    },
    listTitle: 'すべてのプロジェクト',
    visible: '表示中',
    searchProjects: 'プロジェクトを検索',
    searchPlaceholder: '名前またはサービスを検索…',
    updatedJustNow: 'たった今更新',
    searchEmptyTitle: '一致するプロジェクトがありません。',
    searchEmptyBody: 'プロジェクト、サービス、またはリポジトリ名を試してください。',
    createdAt: '作成日 {time}',
    openWorkspace: 'ワークスペースを開く',
    guide: {
      eyebrow: 'プロジェクトの仕組み',
      title: '所有権は広く。実行は明示的に。',
      body: 'プロジェクトは長期的な境界です。各リポジトリは、独自のモデルと自動化構成を持つサービスになります。',
      step1Title: '境界を作成',
      step1Desc: 'プロダクトまたはチームに名前を付けます。',
      step2Title: 'サービスを追加',
      step2Desc: 'リポジトリを明示的に認可します。',
      step3Title: 'タスクを開始',
      step3Desc: '依存関係が準備できてからのみ。',
    },
    create: {
      nameRequired: '名前は必須です。',
      created: 'プロジェクト「{name}」を作成しました。',
      createFailed: 'プロジェクトの作成に失敗しました。',
      submit: 'プロジェクトを作成',
      nameLabel: '名前',
      namePlaceholder: 'demo',
      nameHint: '次にプロジェクトページでリポジトリを追加します。',
    },
    new: {
      nameRequired: '名前は必須です。',
      created: 'プロジェクトを作成しました。',
      createFailed: 'プロジェクトを作成できませんでした。',
      heading: 'プロジェクトを作成',
      subheading: '所有権の境界から始めます。サービスは次です。',
      draft: '下書き',
      step1Eyebrow: '01 / ID',
      section1Title: 'プロジェクトの詳細',
      section1Body: '人々が認識できるプロダクトまたはチームの境界を使用します。',
      nameLabel: '名前',
      namePlaceholder: '例: jcode Cloud',
      nameHint: 'サービス URL を変更せずに、後でプロジェクトの名前を変更できます。',
      step2Eyebrow: '02 / 境界',
      section2Title: 'ここに属するもの',
      section2Body: 'リポジトリは作成後にサービスとして追加されます。',
      calloutStrong: 'リポジトリはまだ作成も接続もされていません。',
      calloutBody: '作成されるワークスペースは空の状態で開き、所有者が各サービスを明示的に認可します。',
      submit: 'プロジェクトを作成',
      asideEyebrow: '作成後',
      asideTitle: 'ワークスペースは空の状態で開きます。',
      asideBody: 'これにより、プロジェクト作成が正直なものになります: Git プロバイダーやモデルがまだ利用できない場合でも、コンテナは存在できます。',
      asideItem1: 'リポジトリをサービスとして接続します。',
      asideItem2: 'Cluster 管理者が付与したモデルを確認します。',
      asideItem3: '必要な依存関係が設定されてからのみタスクを開始します。',
    },
  },

  usage: {
    title: '使用量',
    disclaimer: '使用量は運用テレメトリであり、プロバイダーの請求書ではありません。',
    accountTitle: 'クラウドモデル使用量',
    accountDescription: 'このアカウントのデバイスによるモデル使用量です。',
    proxyOnly: 'Cloud Model Proxy 経由で送信されたリクエストのみが含まれます。',
    unavailable: '利用不可',
    reasonNotReported: 'プロバイダーはこのリクエストの使用量を報告しませんでした。',
    reasonNoRequests: 'この期間に使用量を伴うリクエストはありません。',
    reasonParseError: 'Cloud はプロバイダーの使用量データを解析できませんでした。',
    input: '入力',
    output: '出力',
    cacheRead: 'キャッシュ読み取り',
    cacheWrite: 'キャッシュ書き込み',
    captured: '{captured} / {requests} 件取得',
    captureReported: '報告済み',
    captureIncomplete: '取得不完全',
    reported: '報告値',
    estimated: '推定値',
    uncosted: '未価格',
    details: '価格と取得の詳細',
    requests: 'リクエスト',
    reportedCapture: '完全取得',
    partialCapture: '部分取得',
    unavailableCapture: '利用不可',
    parseErrors: '解析エラー',
    pricingRevisions: '価格リビジョン',
    none: 'なし',
    pricing: '価格',
    pricingTitle: '{model} の価格',
    pricingImmutable: '価格リビジョンは変更できません。変更には新しい有効リビジョンを追加します。',
    addPricingRevision: 'リビジョンを追加',
    currency: '通貨',
    effectiveAt: '有効日時',
    inputRate: '入力 / 100万 token',
    outputRate: '出力 / 100万 token',
    cacheReadRate: 'キャッシュ読み取り / 100万 token',
    cacheWriteRate: 'キャッシュ書き込み / 100万 token',
    pricingHistory: 'リビジョン履歴',
    loadingPricing: '価格を読み込み中…',
    pricingLoadError: '価格を読み込めません',
    noPricingRevisions: '価格リビジョンはまだありません。プロバイダー報告がなければ未価格のままです。',
    pricingValidation: '有効な通貨、有効日時、1つ以上の非負レートを入力してください。',
    pricingCreateError: '価格リビジョンを作成できません',
    loading: '使用量を読み込み中…',
    loadError: '使用量を読み込めません',
    groupBy: 'グループ',
    group: { service: 'リポジトリ', automation: '自動化', model: 'モデル', device: 'デバイス', grant: '権限範囲' },
    range: '期間',
    range24h: '24時間',
    range7: '7日',
    range30: '30日',
    range90: '90日',
    windowNote: '{timeZone} での {range} を表示しています。集計は UTC の1時間単位です。',
    captureHealth: '取得状況',
    costSources: 'コストの出所',
    reportedHelp: 'プロバイダーからの報告値です。Cloud の推定値とは合算しません。',
    estimatedHelp: '変更不可の価格リビジョンから算出します。',
    uncostedHelp: '該当カテゴリのレートがない token です。',
    groupedUsage: '{group}別の使用量',
    noGroups: 'この期間に帰属する使用量はありません。',
    category: {
      input: '入力',
      output: '出力',
      cache_read: 'キャッシュ読み取り',
      cache_write: 'キャッシュ書き込み',
    },
  },
  runDetail: {
    loadingRun: '実行を読み込み中…',
    loadRunError: '実行を読み込めませんでした',
    loadingWorkspace: 'プロジェクトワークスペースを読み込み中…',
    projectName: 'プロジェクト {id}',
    nav: {
      projects: 'プロジェクト',
      repositories: 'リポジトリ',
    },
    railFooter: 'プロジェクトワークスペース',
    repositoryWorkspace: 'リポジトリワークスペース',
    breadcrumbLabel: 'パンくずリスト',
    breadcrumb: {
      tasks: 'タスク',
      detail: '詳細',
    },
    recentTasks: '最近のタスク',
    serviceUnavailable: 'リポジトリ利用不可',
    repositoryUnavailable: 'リポジトリ利用不可',
    noChangesBadge: '変更なし',
    action: {
      stop: '停止',
      retry: '再試行',
      retryOtherModel: 'モデルを切り替える',
      conversation: '会話',
    },
    retryModel: {
      title: '別のモデルで再試行',
      description: '別のモデルで新しい試行を開始します。ワークフロー、コードのリビジョン、権限、デリバリー契約は変更されません。',
      current: '現在のモデル',
      choose: '別のアカウントモデルを選択',
      unknown: '不明なモデル',
      confirm: 'モデルを切り替えて再試行',
	  originalUnavailable: '元のモデルは利用できません。別のアカウントモデルを選択してください。',
    },
    you: 'あなた',
    reviewInProgress: 'レビュー進行中…',
    reviewFailed: 'このレビューは失敗したため、出力は生成されませんでした。',
    noReviewOutput: 'レビュー出力は生成されませんでした。',
    noEvents: '会話イベントは記録されませんでした。',
    waitingForAgent: 'エージェントを待っています…',
    streamDisconnected: 'ライブ更新が切断されました。定期的な更新を表示しています。',
    reconnect: '再接続',
    refreshError: '最新の実行詳細を更新できませんでした — 最後に判明した状態を表示しています。',
    modelLabel: 'モデル',
    toast: {
      permissionDecisionFailed: '権限の決定を送信できませんでした。',
      messageFailed: 'メッセージを送信できませんでした。',
      sessionResumed: 'セッションを再開しました。',
      resumeFailed: 'セッションを再開できませんでした。',
      canceled: '実行をキャンセルしました。',
      cancelFailed: 'キャンセルに失敗しました。',
      retryDispatched: '再試行をディスパッチしました。',
      retryFailed: '再試行に失敗しました。',
      sessionFinishing: 'セッションを終了中 — エージェントが仕上げをしています。',
      finishFailed: 'セッションを終了できませんでした。',
    },
    failure: {
      cloneFailed: 'リポジトリのクローンに失敗しました',
      setupFailed: 'プロジェクトのセットアップに失敗しました',
      agentError: 'エージェントエラー',
      modelRateLimited: 'モデルのレート制限',
      timeout: 'タイムアウトしました',
      pushFailed: 'ブランチのプッシュに失敗しました',
      runFailed: '実行に失敗しました',
      noMessage: '実行はメッセージなしで失敗しました。',
    },
    kind: {
      codeReview: 'コードレビュー',
      session: 'セッション',
      automatedTask: '自動タスク',
      manualTask: '手動タスク',
    },
    originLabel: {
      webhook: 'プロバイダー Webhook',
      schedule: 'スケジュール',
      kanban: 'カンバン',
      prEvent: 'PR イベント',
      manual: '手動',
    },
    session: {
      sessionQueued: 'セッションがキュー待ち — 空き同時実行スロットを待っています。',
      sessionStarting: 'セッション開始中 — ワークスペースがスケジュールされています。',
      sessionActionsHint: '「終了」は現在のターンの後にエージェントに仕上げをさせます。「キャンセル」は即座に停止します。',
      finishSession: 'セッションを終了',
      resumeHint: 'このセッションを続行 — エージェントは同じコンテキストを保持します。',
    },
    composer: {
      continuePlaceholder: 'このタスクを続行…',
      followUpPlaceholder: 'フォローアップをキューに追加 — 現在のターンの後に実行されます…',
      serviceDefault: 'リポジトリデフォルト',
      useServiceModel: 'リポジトリに設定されたモデルを使用',
      modelFixed: 'このアクティブなセッションではモデルは固定されています',
      messageInput: 'メッセージ入力',
      attachmentsUnavailableTitle: 'Cloud セッションではまだ添付ファイルを利用できません。',
      attachmentsUnavailable: '添付ファイル利用不可',
      modelAccessLocked: 'モデルとアクセスは再開時に適用されます。',
      modeCeilingHint: 'Cloud セッションでは承認、プラン、自動モードを利用できます。',
      queue: 'キュー',
      send: '送信',
      sendMessage: 'メッセージを送信',
    },
    model: {
      disabledTitle: 'アクティブなエージェントセッションは既存のモデルを保持します。',
      chooseTitle: '再開するセッションのモデルを選択します。',
      filterModels: 'モデルを絞り込み',
      filterModelsPlaceholder: 'モデルを絞り込み…',
      modelsHeading: 'モデル',
      noMatchingModels: '一致するモデルがありません',
    },
    permission: {
      askForApproval: '承認を求める',
      askForApprovalSub: 'エージェントはツールを実行する前に確認します',
      plan: '計画',
      planSub: 'Cloud セッションではまだ利用できません',
      fullAccess: 'フルアクセス',
      fullAccessSub: 'エージェントは確認なしで操作できます',
      permissionMode: '権限モード',
      disabledTitle: 'アクティブなエージェントセッションは既存の権限モードを保持します。',
      chooseTitle: '再開するエージェントが権限を求める方法を選択します。',
    },
    inspector: {
      runDetailsLabel: '実行の詳細',
      identityAndSource: '依頼者と実行元',
      requestedBy: 'リクエスト元',
      accountableTo: '責任者',
      triggeredFrom: 'トリガー元',
      executedFor: '実行対象',
      project: 'プロジェクト',
      repository: 'リポジトリ',
      dispatchSnapshot: 'ディスパッチ時のスナップショット',
      writtenBackAs: '書き戻し ID',
      externalActor: '外部 ID',
      ruleOwner: 'ルール所有者',
      botOrApp: 'Bot / アプリ',
      notAttributed: '帰属なし',
      notApplicable: '該当なし',
      technicalIdentity: '技術的な実行情報',
      runtimePrincipal: 'ランタイム',
      attribution: '帰属',
      source: 'ソース',
      precisionExact: '正確',
      precisionLinkedExternal: '外部 ID にリンク',
      precisionRuleOwner: 'ルール所有者に帰属',
      precisionUnattributed: '帰属なし',
      runOverview: '実行の概要',
      service: 'サービス',
      unavailable: '利用不可',
      trigger: 'トリガー',
      notReported: '報告なし',
      permission: '権限',
      askBeforeActions: '操作前に確認',
      workspace: 'ワークスペース',
      changes: '変更',
      noCodeChanges: 'コード変更なし',
      reviewPatch: '完全なパッチをレビュー',
      loadingChangeSummary: '変更サマリーを読み込み中…',
      diffUnavailable: 'diff 利用不可',
      diffAfterAgent: 'エージェントが diff を生成した後に利用可能',
      viewCompleteDiff: '完全な diff を表示',
      openPrDetails: 'プルリクエストの詳細を開く',
      draftPr: 'ドラフト PR',
	  executionStatus: '実行ステータス',
	  deliveryStatus: 'デリバリーステータス',
	  deliveryKind: '配信先',
	  deliveryIssue: 'デリバリーの問題',
	  deliveryUnknown: '未報告',
	  delivery: { not_required: '不要', pending: '保留中', delivered: '配信済み', failed: '失敗' },
	  deliveryKindLabel: { artifact: '成果物', pull_request: 'プルリクエスト', branch_update: 'ブランチ更新', review_comment: 'レビューコメント' },
      execution: '実行',
      started: '開始',
      notStarted: '未開始',
      duration: '所要時間',
      runId: '実行 ID',
      retryOf: '再試行元',
      resumedFrom: '再開元',
      resumedFromLink: '{id} から再開',
    },
    origin: {
      fromPrComment: 'PR コメントから',
      scheduled: 'スケジュール済み',
      kanbanAutomation: 'カンバン自動化',
      prEventAutomation: 'PR イベント自動化',
    },
    diff: {
      runFailedNoDiff: 'この実行は失敗したため、diff は生成されませんでした。',
      diffAfterArtifact: 'diff はエージェントがアーティファクトを生成した後に利用可能になります。',
      noCodeChanges: 'この実行はコードを変更しませんでした。',
      loadingDiff: 'diff を読み込み中…',
      loadDiffError: 'diff を読み込めませんでした',
    },
    failedSubmission: {
      notSent: 'メッセージは送信されませんでした。',
      draftPreserved: '下書きは保持されています。',
      retryUnsent: '未送信メッセージを再試行',
    },
  },
};
